import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "./Footer";
import Header from "./Header";

import HealthcareImg from "./assets/img/Healthcare.jpeg";
import ManufacturingImg from "./assets/img/Manufacturing.png";
import MobillityImg from "./assets/img/Mobillity.png";
import HospitalityImg from "./assets/img/Hospitality.png";
import FashionImg from "./assets/img/Fashion.png";
import EducationImg from "./assets/img/Education.png";
import Construction from "./assets/img/Construction.png";
import recommendedImg from "./assets/img/recommended.png";
import TroyAnderson from "./assets/img/DrTroyAnderson.png";
import PhoenixNeurologyLogo from "./assets/img/PhoenixNeurology.png";
import starSkyConnectLogo from "./assets/img/starSkyConnect.png";
import chunaRailwayConstructionLogo from "./assets/img/chunaRailwayConstruction.png";
import SpicerAdventistUniversityLogo from "./assets/img/SpicerAdventistUniversity.png";

import mvpImgs from "./assets/img/mvpImg-1.png";
import mvpIco1 from "./assets/img/MVPIco-1.png";
import mvpIco2 from "./assets/img/MVPIco-2.png";
import mvpIco3 from "./assets/img/MVPIco-3.png";
import mvpIco4 from "./assets/img/MVPIco-4.png";
import mvpIco5 from "./assets/img/MVPIco-5.png";
import mvpIco6 from "./assets/img/MVPIco-6.png";
import MVPHoverIco1 from "./assets/img/MVPHoverIco-1.png";
import MVPHoverIco2 from "./assets/img/MVPHoverIco-2.png";
import MVPHoverIco3 from "./assets/img/MVPHoverIco-3.png";
import MVPHoverIco4 from "./assets/img/MVPHoverIco-4.png";
import MVPHoverIco5 from "./assets/img/MVPHoverIco-5.png";
import MVPHoverIco6 from "./assets/img/MVPHoverIco-6.png";

import AdobeImg from "./assets/img/partners/adobe.png";
import GoogleImg from "./assets/img/partners/google.png";
import MicrosoftImg from "./assets/img/partners/microsoft.png";
import AwsImg from "./assets/img/partners/aws.png";
import ShopifyImg from "./assets/img/partners/shopify.png";
import ZohoImg from "./assets/img/partners/Zoho.png";
import IBMImg from "./assets/img/partners/IBM.png";
import DatabricksImg from "./assets/img/partners/databricks.png";
import OpenAIImg from "./assets/img/partners/OpenAI.png";
import TheVergeImg from "./assets/img/partners/theVerge.png";

import capabilitiesIco77 from "./assets/img/capabilitiesIco-77.png";
import capabilitiesIco88 from "./assets/img/capabilitiesIco-88.png";
import capabilitiesIco99 from "./assets/img/capabilitiesIco-99.png";

import productsliderImg1 from "./assets/img/productsliderImg-1.png";
import productsliderImg2 from "./assets/img/productsliderImg-2.png";
import productsliderImg3 from "./assets/img/productsliderImg-3.png";
import productsliderImg4 from "./assets/img/productsliderImg-4.png";

import Video1 from "./assets/video/video-1.mp4";
import Video3 from "./assets/video/video-3.mp4";
import Video4 from "./assets/video/video-4.mp4";
import Video5 from "./assets/video/video-5.mp4";
import Video6 from "./assets/video/video-6.mp4";
const Home = () => {
  const [lgShow, setLgShow] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    interest: "",
    message: "",
  });
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      type: "contact",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      alert("Please verify the reCAPTCHA before submitting.");
      return;
    }

    await axios
      .post(
        "https://p506xqqura.execute-api.ap-south-1.amazonaws.com/contact",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then(() => {
        setFormData({
          name: "",
          email: "",
          mobile: "",
          interest: "",
          message: "",
        });
        setLgShow(false);
        setShowThankYou(true);
        recaptchaRef.current.reset();
        setCaptchaToken(null);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert(
          "An error occurred while submitting the form. Please try again later.",
        );
      });
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };


  const productSlider = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonialSlider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  // const bannerSlider = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   autoplay: true,
  //   autoplaySpeed: 6000,
  //   speed: 1600,
  //   fade: true,
  //   cssEase: "linear",
  // };

  const bannerSlider = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 1600,
    fade: true,
    cssEase: "linear",

    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, []);

  const settings1 = {
    asNavFor: nav2,
    ref: (slider) => (slider1.current = slider),
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1600,
    fade: true,
    cssEase: "linear",
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          fade: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          fade: false,
        },
      },
    ],
  };

  const settings2 = {
    asNavFor: nav1,
    ref: (slider) => (slider2.current = slider),
    slidesToShow: 4,
    swipeToSlide: true,
    focusOnSelect: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1600,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const canvasRef = useRef(null);
  let ctx;
  let w, h;
  const options = {
    num: 40,
    particle: {
      color: "rgba(255,255,255,0.6)",
      szMin: 0.5,
      szMax: 1,
      spMin: 0.05,
      spMax: 0.5,
    },
    link: { color: "rgba(255,255,255,0.3)", maxDist: 120 },
  };
  const pi2 = Math.PI * 2;
  const degrad = Math.PI / 180.0;
  let particles;

  class Particle {
    constructor() {
      this.p = { x: Math.random() * w, y: Math.random() * h };
      this.s = options.particle.spMin + Math.random() * options.particle.spMax;
      this.r = options.particle.szMin + Math.random() * options.particle.szMax;
      this.d = Math.random() * pi2;
      this.v = { x: Math.cos(this.d) * this.s, y: Math.sin(this.d) * this.s };
    }
    setDir(d) {
      this.d = d;
      this.v.x = Math.cos(this.d) * this.s;
      this.v.y = Math.sin(this.d) * this.s;
    }
    wrap() {
      if (this.p.x < 0 || this.p.x > w || this.p.y < 0 || this.p.y > h)
        this.setDir(this.d + Math.random() * degrad * 5);
    }
    update() {
      this.p.x += this.v.x;
      this.p.y += this.v.y;
      this.wrap();
    }
    draw() {
      ctx.beginPath();
      ctx.arc(this.p.x, this.p.y, this.r, 0, pi2);
      ctx.fillStyle = options.particle.color;
      ctx.fill();
    }
    drawLink(other) {
      ctx.save();
      ctx.globalAlpha = 1 - this.distanceTo(other) / options.link.maxDist;
      ctx.beginPath();
      ctx.moveTo(this.p.x, this.p.y);
      ctx.lineWidth = this.r;
      ctx.lineTo(other.p.x, other.p.y);
      ctx.strokeStyle = options.link.color;
      ctx.stroke();
      ctx.restore();
    }
    closeTo(other) {
      let xd = other.p.x - this.p.x;
      let yd = other.p.y - this.p.y;

      return xd * xd + yd * yd <= options.link.maxDist * options.link.maxDist;
    }
    distanceTo(other) {
      let xd = other.p.x - this.p.x;
      let yd = other.p.y - this.p.y;

      return Math.sqrt(xd * xd + yd * yd);
    }
  }

  const resize = () => {
    w = canvasRef.current.width = window.innerWidth;
    h = canvasRef.current.height = window.innerHeight;
  };

  let integrate = () => {
    ctx.clearRect(0, 0, w, h);
    particles.forEach((a) => {
      a.update();
      a.draw();
      particles.forEach((b) => {
        if (a === b || !b.closeTo(a)) return;
        a.drawLink(b);
      });
    });
    window.requestAnimationFrame(integrate);
  };

  const init = () => {
    ctx = canvasRef.current.getContext("2d");
    resize();
    particles = [...Array(options.num)].map((_, i) => new Particle());
    integrate();
  };

  useEffect(() => {
    init();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  const [currentSlide, setCurrentSlide] = useState(1);
  const [isPaused, setIsPaused] = useState(false);

  // Function to change the slide
  const changeSlide = () => {
    if (!isPaused) {
      setCurrentSlide((prevSlide) => (prevSlide === 5 ? 1 : prevSlide + 1));
    }
  };

  // Start the auto-scroll
  useEffect(() => {
    const slideInterval = setInterval(changeSlide, 7000);
    return () => clearInterval(slideInterval);
  }, []);

  // Function to pause the auto-scroll
  const pauseSlide = () => {
    setIsPaused(true);
  };

  // Function to resume the auto-scroll
  const resumeSlide = () => {
    setIsPaused(false);
  };

  return (
    <>
      <Helmet>
        <title>
          Hummingtec – IT Services, AI/ML Consulting & Custom Software
        </title>
        <meta
          name="description"
          content="Hummingtec delivers AI, ML, IoT, and custom software solutions. From design to deployment, we build smart, scalable, future-ready IT systems."
        />
        <meta
          name="keywords"
          content="AI/ML,  Artificial intelligence, BlockChain, Machine Learning, humingtec, hummingtec, Salesforce CRM, Zoho CRM, Custom CRM, Social Media Management, SEO, Startups"
        />
      </Helmet>
      <Header></Header>
      <div className="mainContent">
        <div class="bannerWrap">
          <Slider {...bannerSlider}>
            {/* <div className="itemWrap">
                            <div className="innerWrap">
                                <div class="container-fluid pad0">
                                    <div class="row justify-content-center">
                                        <div class="col-md-12 pad0">
                                            <div class="videoWrap">
                                                <video autoPlay loop muted playsInline>
                                                    <source src={Video5} type="video/mp4" />
                                                </video>
                                            </div>
                                            <div className="dataWrap">
                                                <h2>Unlock the Power of Digital Agents with Hummingtec</h2>
                                                <p>Transforming Businesses with Intelligent Digital Agents.</p>
                                                <Link to="/DigitalAgents">Explore More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
            <div className="itemWrap">
              <div className="innerWrap">
                <div class="container-fluid pad0">
                  <div class="row justify-content-center">
                    <div class="col-md-12 pad0">
                      <div class="videoWrap">
                        <video autoPlay loop muted playsInline>
                          <source src={Video6} type="video/mp4" />
                        </video>
                      </div>
                      <div className="dataWrap">
                        <h2>
                          Your Business Runs on Data. Let's Turn It Into
                          Intelligent Action.
                        </h2>
                        <p>
                          Automate manual processes, reduce operating costs, and
                          make smarter decisions with custom AI solutions
                          tailored to your operations.
                        </p>
                        <Link to="">Build Your AI Prototype</Link>
                        <button className="btn" onClick={() => setLgShow(true)}>
                          Get Quote
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="itemWrap">
              <div className="innerWrap">
                <div class="container-fluid pad0">
                  <div class="row justify-content-center">
                    <div class="col-md-12 pad0">
                      <div class="videoWrap">
                        <video autoPlay loop muted playsInline>
                          <source src={Video4} type="video/mp4" />
                        </video>
                      </div>
                      <div className="dataWrap">
                        <h2>Unleash the power of Artificial Intelligence</h2>
                        <p>
                          AI That Understands Your Data — and Your Business.
                        </p>
                        <Link to="/AIML">Explore More</Link>
                        <button className="btn" onClick={() => setLgShow(true)}>
                          Get Quote
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="itemWrap">
              <div className="innerWrap">
                <div class="container-fluid pad0">
                  <div class="row justify-content-center">
                    <div class="col-md-12 pad0">
                      <div class="videoWrap">
                        <video autoPlay loop muted playsInline>
                          <source src={Video3} type="video/mp4" />
                        </video>
                      </div>
                      <div className="dataWrap">
                        <h2>Custom Application Development</h2>
                        <p>
                          Unlock insights, automate workflows, and forecast your
                          business future.
                        </p>
                        <Link to="/CustomApplication">Explore More</Link>
                        <button className="btn" onClick={() => setLgShow(true)}>
                          Get Quote
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="itemWrap">
              <div className="innerWrap">
                <div class="container-fluid pad0">
                  <div class="row justify-content-center">
                    <div class="col-md-12 pad0">
                      <div class="videoWrap video3">
                        <video autoPlay loop muted playsInline>
                          <source src={Video1} type="video/mp4" />
                        </video>
                      </div>
                      <div className="dataWrap">
                        <h2>Mobile Apps</h2>
                        <p>
                          Crafting seamless mobile experiences for the digital
                          age.
                        </p>
                        <Link to="/MobileApplication">Explore More</Link>
                        <button className="btn" onClick={() => setLgShow(true)}>
                          Get Quote
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
        <div className="mvpWrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <div className="mvpBoxWrap">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="leftDataWrap">
                        <h2>Want to build an MVP?</h2>
                        <h4>
                          Ready to turn your brilliant idea into a reality?
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="rightDataWrap">
                        <div className="imgWrap">
                          <img src={mvpImgs} className="img-fluid" alt="" />
                        </div>
                        <ul>
                          <li>
                            <div className="itemWrap">
                              <div className="icoWrap">
                                <img
                                  src={mvpIco1}
                                  className="img-fluid imgNoHover"
                                  alt=""
                                />
                                <img
                                  src={MVPHoverIco1}
                                  className="img-fluid imgHover"
                                  alt=""
                                />
                              </div>
                              <div className="dataWrap">
                                <h3>01</h3>
                                <h2>Understand Needs</h2>
                                <p>
                                  Deeply understand market and user needs for
                                  precise targeting.
                                </p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="itemWrap">
                              <div className="icoWrap">
                                <img
                                  src={mvpIco2}
                                  className="img-fluid imgNoHover"
                                  alt=""
                                />
                                <img
                                  src={MVPHoverIco2}
                                  className="img-fluid imgHover"
                                  alt=""
                                />
                              </div>
                              <div className="dataWrap">
                                <h3>02</h3>
                                <h2>Craft MVP</h2>
                                <p>
                                  Focus on essential features for immediate,
                                  impactful value delivery.
                                </p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="itemWrap">
                              <div className="icoWrap">
                                <img
                                  src={mvpIco3}
                                  className="img-fluid imgNoHover"
                                  alt=""
                                />
                                <img
                                  src={MVPHoverIco3}
                                  className="img-fluid imgHover"
                                  alt=""
                                />
                              </div>
                              <div className="dataWrap">
                                <h3>03</h3>
                                <h2>Map Journey</h2>
                                <p>
                                  Develop a flexible, detailed roadmap guiding
                                  each development step.
                                </p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="itemWrap">
                              <div className="icoWrap">
                                <img
                                  src={mvpIco4}
                                  className="img-fluid imgNoHover"
                                  alt=""
                                />
                                <img
                                  src={MVPHoverIco4}
                                  className="img-fluid imgHover"
                                  alt=""
                                />
                              </div>
                              <div className="dataWrap">
                                <h3>04</h3>
                                <h2>Choose Tools</h2>
                                <p>
                                  Select optimal, scalable technologies for
                                  efficient MVP development.
                                </p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="itemWrap">
                              <div className="icoWrap">
                                <img
                                  src={mvpIco5}
                                  className="img-fluid imgNoHover"
                                  alt=""
                                />
                                <img
                                  src={MVPHoverIco5}
                                  className="img-fluid imgHover"
                                  alt=""
                                />
                              </div>
                              <div className="dataWrap">
                                <h3>05</h3>
                                <h2>Create & Iterate</h2>
                                <p>
                                  Build MVP, rigorously test, and refine based
                                  on feedback.
                                </p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="itemWrap">
                              <div className="icoWrap">
                                <img
                                  src={mvpIco6}
                                  className="img-fluid imgNoHover"
                                  alt=""
                                />
                                <img
                                  src={MVPHoverIco6}
                                  className="img-fluid imgHover"
                                  alt=""
                                />
                              </div>
                              <div className="dataWrap">
                                <h3>06</h3>
                                <h2>Grow Together</h2>
                                <p>
                                  Prepare for scaling, ensuring MVP adapts and
                                  grows with you.
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="ctaWrap">
                        <button className="btn" onClick={() => setLgShow(true)}>
                          Get a free consultation for your MVP
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="howWeBuildWrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <div className="row">
                  <div className="col-md-12">
                    <div className="titleWrap">
                      <h2>How We Build Your AI Prototype in 4 Steps</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="howWeBuidList">
                      <ul>
                        <li>
                          <div className="itemWrap">
                            <div className="numWrap">
                              <h2>1</h2>
                            </div>
                            <div className="dataWrap">
                              <h2>Discovery & Strategy Call</h2>
                              <p>
                                We start with a 30-minute session to understand
                                your business goals, challenges, and the data
                                you have. We identify the best-fit AI use case
                                for a rapid prototype.
                              </p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="numWrap">
                              <h2>2</h2>
                            </div>
                            <div className="dataWrap">
                              <h2>Data Review & Feasibility Check</h2>
                              <p>
                                Our engineers analyse your data (spreadsheets,
                                logs, documents, APIs) to ensure quality,
                                relevance, and scope. You’ll get a clear summary
                                of what can be achieved in the prototype phase.
                              </p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="numWrap">
                              <h2>3</h2>
                            </div>
                            <div className="dataWrap">
                              <h2>AI Model Development</h2>
                              <p>
                                We build a custom model tailored to your
                                business — whether it's predicting, classifying,
                                summarizing, or automating. This includes
                                dashboards or chatbot interfaces, depending on
                                the use case.
                              </p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="numWrap">
                              <h2>4</h2>
                            </div>
                            <div className="dataWrap">
                              <h2>Delivery & Recommendation Report</h2>
                              <p>
                                We build a custom model tailored to your
                                business — whether it's predicting, classifying,
                                summarizing, or automating. This includes
                                dashboards or chatbot interfaces, depending on
                                the use case.
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="focusWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Delivering Excellence</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul className="focusList">
                  <li>
                    <div className="itemWrap">
                      <div className="numWrap">
                        <p>01</p>
                        <p>04</p>
                      </div>
                      <div className="dataWrap">
                        <div className="leftWrap">
                          {/* <span>Focus</span> */}
                          <h2>Digital Transformation Services</h2>
                          <p>
                            Empowering Your Business with Cutting-Edge Digital
                            Solutions!
                          </p>
                          <ul>
                            <li>Strategic Planning & Agile Roadmaps</li>
                            <li>Automation & Process Optimization</li>
                            <li>Proactive Security & Compliance</li>
                            <li>Data Analytics & Business Intelligence</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="numWrap">
                        <p>02</p>
                        <p>04</p>
                      </div>
                      <div className="dataWrap">
                        <div className="leftWrap">
                          {/* <span>Focus</span> */}
                          <h2>Excellence in Software Development</h2>
                          <p>Build High-Impact Software That Shines!</p>
                          <ul>
                            <li>Holistic Full-Stack Engineering</li>
                            <li>Scalable Mobile & Web Apps</li>
                            <li>Rigorous Quality Assurance</li>
                            <li>User Interface and Experience Design</li>
                            <li>Modular, Scalable Architecture</li>
                            <li>Continuous Integration & Delivery</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="numWrap">
                        <p>03</p>
                        <p>04</p>
                      </div>
                      <div className="dataWrap">
                        <div className="leftWrap">
                          {/* <span>Focus</span> */}
                          <h2>Emerging Tech Innovation</h2>
                          <p>Empower Your Business with Next-Level Tech!</p>
                          <ul>
                            <li>IoT Integration</li>
                            <li>AI-Powered Solutions</li>
                            <li>Cloud Computing Solutions</li>
                            <li>AR/VR Immersive Experiences</li>
                            <li>Conversational AI</li>
                            <li>Blockchain Security</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="numWrap">
                        <p>04</p>
                        <p>04</p>
                      </div>
                      <div className="dataWrap">
                        <div className="leftWrap">
                          {/* <span>Focus</span> */}
                          <h2>Legacy Systems Modernization</h2>
                          <p>Refresh Your Legacy Systems for the Future!</p>
                          <ul>
                            <li>Comprehensive Platform Overhaul</li>
                            <li>Code Refactoring</li>
                            <li>Human-Centric UX/UI Redesign</li>
                            <li>Customer-Focused Redesign</li>
                            <li>Security & Compliance Enhancement</li>
                            <li>Continuous Monitoring & Improvement</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  {/* <li>
                                        <div className="itemWrap">
                                            <div className="numWrap">
                                                <p>05</p>
                                                <p>05</p>
                                            </div>
                                            <div className="dataWrap">
                                                <div className="leftWrap">
                                                    <span>Focus</span>
                                                    <h2>Mordernization</h2>
                                                    <p>Re-Imagining Legacy Technology</p>
                                                    <ul>
                                                        <li>Platform Refresh</li>
                                                        <li>Refactoring Code</li>
                                                        <li>HCI UX/UI</li>
                                                        <li>Customer Experience</li>
                                                        <li>Security</li>
                                                        <li>Compliance</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="serviceItemWrap">
          <canvas ref={canvasRef} className="network-background-canvas" />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                <div className="titleWrap">
                  <h2>capabilities</h2>
                  <p>
                    Explore the dynamic capabilities of Hummingtec, a leading
                    technology solutions provider specializing in AI and Machine
                    Learning (AI/ML), Customer Relationship Management (CRM),
                    Digital Transformation, Custom Application Development,
                    Mobile App Development, and comprehensive Security & Testing
                    services. We deliver tailored software solutions designed to
                    drive innovation, enhance operational efficiency, and fuel
                    sustainable business growth. With deep industry expertise
                    and cutting-edge technology, Hummingtec empowers businesses
                    to achieve digital excellence and stay competitive in an
                    evolving market landscape. Partner with us to unlock the
                    full potential of your digital transformation journey and
                    accelerate success through customized, scalable, and secure
                    technology solutions.
                  </p>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="col-md-12">
                  <div class="main">
                    <ul className="bgcloudList">
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="200"
                          height="200"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M60 29H48c-1.66 0-3-1.34-3-3s1.34-3 3-3h9c1.66 0 3-1.34 3-3s-1.34-3-3-3H23c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2-.9 2-2s-.9-2-2-2H3c-1.1 0-2 .9-2 2s.9 2 2 2h7c1.1 0 2 .9 2 2s-.9 2-2 2H9c-1.66 0-3 1.34-3 3s1.34 3 3 3h16c1.66 0 3 1.34 3 3s-1.34 3-3 3h-1c-1.66 0-3 1.34-3 3s1.34 3 3 3h36c1.66 0 3-1.34 3-3s-1.34-3-3-3zM29 45h4c1.1 0 2-.9 2-2s-.9-2-2-2H17c-1.1 0-2 .9-2 2s.9 2 2 2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-7c-1.66 0-3 1.34-3 3s1.34 3 3 3h34c1.66 0 3-1.34 3-3s-1.34-3-3-3H29c-1.1 0-2-.9-2-2s.9-2 2-2z"
                              opacity="1"
                            ></path>
                            <circle cx="42" cy="11" r="2" opacity="1"></circle>
                            <path
                              d="M12 29H6c-1.66 0-3 1.34-3 3s1.34 3 3 3h6c1.66 0 3-1.34 3-3s-1.34-3-3-3z"
                              opacity="1"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="200"
                          height="200"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M60 29H48c-1.66 0-3-1.34-3-3s1.34-3 3-3h9c1.66 0 3-1.34 3-3s-1.34-3-3-3H23c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2-.9 2-2s-.9-2-2-2H3c-1.1 0-2 .9-2 2s.9 2 2 2h7c1.1 0 2 .9 2 2s-.9 2-2 2H9c-1.66 0-3 1.34-3 3s1.34 3 3 3h16c1.66 0 3 1.34 3 3s-1.34 3-3 3h-1c-1.66 0-3 1.34-3 3s1.34 3 3 3h36c1.66 0 3-1.34 3-3s-1.34-3-3-3zM29 45h4c1.1 0 2-.9 2-2s-.9-2-2-2H17c-1.1 0-2 .9-2 2s.9 2 2 2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-7c-1.66 0-3 1.34-3 3s1.34 3 3 3h34c1.66 0 3-1.34 3-3s-1.34-3-3-3H29c-1.1 0-2-.9-2-2s.9-2 2-2z"
                              opacity="1"
                            ></path>
                            <circle cx="42" cy="11" r="2" opacity="1"></circle>
                            <path
                              d="M12 29H6c-1.66 0-3 1.34-3 3s1.34 3 3 3h6c1.66 0 3-1.34 3-3s-1.34-3-3-3z"
                              opacity="1"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="200"
                          height="200"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M60 29H48c-1.66 0-3-1.34-3-3s1.34-3 3-3h9c1.66 0 3-1.34 3-3s-1.34-3-3-3H23c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2-.9 2-2s-.9-2-2-2H3c-1.1 0-2 .9-2 2s.9 2 2 2h7c1.1 0 2 .9 2 2s-.9 2-2 2H9c-1.66 0-3 1.34-3 3s1.34 3 3 3h16c1.66 0 3 1.34 3 3s-1.34 3-3 3h-1c-1.66 0-3 1.34-3 3s1.34 3 3 3h36c1.66 0 3-1.34 3-3s-1.34-3-3-3zM29 45h4c1.1 0 2-.9 2-2s-.9-2-2-2H17c-1.1 0-2 .9-2 2s.9 2 2 2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-7c-1.66 0-3 1.34-3 3s1.34 3 3 3h34c1.66 0 3-1.34 3-3s-1.34-3-3-3H29c-1.1 0-2-.9-2-2s.9-2 2-2z"
                              opacity="1"
                            ></path>
                            <circle cx="42" cy="11" r="2" opacity="1"></circle>
                            <path
                              d="M12 29H6c-1.66 0-3 1.34-3 3s1.34 3 3 3h6c1.66 0 3-1.34 3-3s-1.34-3-3-3z"
                              opacity="1"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="200"
                          height="200"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M60 29H48c-1.66 0-3-1.34-3-3s1.34-3 3-3h9c1.66 0 3-1.34 3-3s-1.34-3-3-3H23c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2-.9 2-2s-.9-2-2-2H3c-1.1 0-2 .9-2 2s.9 2 2 2h7c1.1 0 2 .9 2 2s-.9 2-2 2H9c-1.66 0-3 1.34-3 3s1.34 3 3 3h16c1.66 0 3 1.34 3 3s-1.34 3-3 3h-1c-1.66 0-3 1.34-3 3s1.34 3 3 3h36c1.66 0 3-1.34 3-3s-1.34-3-3-3zM29 45h4c1.1 0 2-.9 2-2s-.9-2-2-2H17c-1.1 0-2 .9-2 2s.9 2 2 2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-7c-1.66 0-3 1.34-3 3s1.34 3 3 3h34c1.66 0 3-1.34 3-3s-1.34-3-3-3H29c-1.1 0-2-.9-2-2s.9-2 2-2z"
                              opacity="1"
                            ></path>
                            <circle cx="42" cy="11" r="2" opacity="1"></circle>
                            <path
                              d="M12 29H6c-1.66 0-3 1.34-3 3s1.34 3 3 3h6c1.66 0 3-1.34 3-3s-1.34-3-3-3z"
                              opacity="1"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="200"
                          height="200"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M60 29H48c-1.66 0-3-1.34-3-3s1.34-3 3-3h9c1.66 0 3-1.34 3-3s-1.34-3-3-3H23c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2-.9 2-2s-.9-2-2-2H3c-1.1 0-2 .9-2 2s.9 2 2 2h7c1.1 0 2 .9 2 2s-.9 2-2 2H9c-1.66 0-3 1.34-3 3s1.34 3 3 3h16c1.66 0 3 1.34 3 3s-1.34 3-3 3h-1c-1.66 0-3 1.34-3 3s1.34 3 3 3h36c1.66 0 3-1.34 3-3s-1.34-3-3-3zM29 45h4c1.1 0 2-.9 2-2s-.9-2-2-2H17c-1.1 0-2 .9-2 2s.9 2 2 2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-7c-1.66 0-3 1.34-3 3s1.34 3 3 3h34c1.66 0 3-1.34 3-3s-1.34-3-3-3H29c-1.1 0-2-.9-2-2s.9-2 2-2z"
                              opacity="1"
                            ></path>
                            <circle cx="42" cy="11" r="2" opacity="1"></circle>
                            <path
                              d="M12 29H6c-1.66 0-3 1.34-3 3s1.34 3 3 3h6c1.66 0 3-1.34 3-3s-1.34-3-3-3z"
                              opacity="1"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="200"
                          height="200"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M60 29H48c-1.66 0-3-1.34-3-3s1.34-3 3-3h9c1.66 0 3-1.34 3-3s-1.34-3-3-3H23c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2-.9 2-2s-.9-2-2-2H3c-1.1 0-2 .9-2 2s.9 2 2 2h7c1.1 0 2 .9 2 2s-.9 2-2 2H9c-1.66 0-3 1.34-3 3s1.34 3 3 3h16c1.66 0 3 1.34 3 3s-1.34 3-3 3h-1c-1.66 0-3 1.34-3 3s1.34 3 3 3h36c1.66 0 3-1.34 3-3s-1.34-3-3-3zM29 45h4c1.1 0 2-.9 2-2s-.9-2-2-2H17c-1.1 0-2 .9-2 2s.9 2 2 2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-7c-1.66 0-3 1.34-3 3s1.34 3 3 3h34c1.66 0 3-1.34 3-3s-1.34-3-3-3H29c-1.1 0-2-.9-2-2s.9-2 2-2z"
                              opacity="1"
                            ></path>
                            <circle cx="42" cy="11" r="2" opacity="1"></circle>
                            <path
                              d="M12 29H6c-1.66 0-3 1.34-3 3s1.34 3 3 3h6c1.66 0 3-1.34 3-3s-1.34-3-3-3z"
                              opacity="1"
                            ></path>
                          </g>
                        </svg>
                      </li>
                    </ul>
                    <ul class="bigCircle">
                      <li class="iconBlock">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="38"
                          height="38"
                          x="0"
                          y="0"
                          viewBox="0 0 58 60"
                        >
                          <g>
                            <g fill="none" fill-rule="evenodd">
                              <g transform="translate(1 1)">
                                <ellipse
                                  cx="28"
                                  cy="29"
                                  fill="#00bcd4"
                                  rx="15"
                                  ry="29"
                                  opacity="1"
                                  data-original="#00bcd4"
                                ></ellipse>
                                <path
                                  fill="#00838f"
                                  d="M28 0c-.503 0-1.006.05-1.5.145C34.08 1.6 40 13.963 40 29s-5.92 27.4-13.5 28.855c.494.096.997.144 1.5.145 8.284 0 15-12.984 15-29S36.284 0 28 0z"
                                  opacity="1"
                                  data-original="#00838f"
                                ></path>
                                <path
                                  fill="#00bcd4"
                                  d="M54.16 40.24c.36-3.34-1.03-7.28-3.81-11.24a41.473 41.473 0 0 0-7.98-8.3 53.4 53.4 0 0 0-6.87-4.69 54.443 54.443 0 0 0-7.49-3.61H28a41.525 41.525 0 0 0-11.17-2.75c-5.19-.46-9.56.45-12.24 2.8l-2.75 5.31C1.48 21.1 2.87 25.04 5.65 29a41.473 41.473 0 0 0 7.98 8.3 53.4 53.4 0 0 0 6.87 4.69 54.443 54.443 0 0 0 7.49 3.61H28a41.525 41.525 0 0 0 11.17 2.75c5.19.46 9.56-.45 12.24-2.8z"
                                  opacity="1"
                                  data-original="#00bcd4"
                                ></path>
                                <path
                                  fill="#00838f"
                                  d="M50.35 29a41.473 41.473 0 0 0-7.98-8.3 53.4 53.4 0 0 0-6.87-4.69 54.443 54.443 0 0 0-7.49-3.61H28a41.525 41.525 0 0 0-11.17-2.75 26.741 26.741 0 0 0-4.043-.059c.347.018.688.028 1.043.059A41.525 41.525 0 0 1 25 12.4h.01a54.443 54.443 0 0 1 7.49 3.61 53.4 53.4 0 0 1 6.87 4.69 41.473 41.473 0 0 1 7.98 8.3c2.78 3.96 4.17 7.9 3.81 11.24l-2.75 5.31c-1.948 1.708-4.8 2.646-8.2 2.859 4.727.254 8.7-.67 11.2-2.859l2.75-5.31c.36-3.34-1.03-7.28-3.81-11.24z"
                                  opacity="1"
                                  data-original="#00838f"
                                ></path>
                                <path
                                  fill="#00bcd4"
                                  d="M54.16 17.76c.36 3.34-1.03 7.28-3.81 11.24a41.473 41.473 0 0 1-7.98 8.3 53.4 53.4 0 0 1-6.87 4.69A54.546 54.546 0 0 1 28 45.6h-.01a41.551 41.551 0 0 1-11.16 2.75c-5.19.46-9.56-.45-12.24-2.8l-2.75-5.31C1.48 36.9 2.87 32.96 5.65 29a41.473 41.473 0 0 1 7.98-8.3 53.4 53.4 0 0 1 6.87-4.69A54.546 54.546 0 0 1 28 12.4h.01a41.551 41.551 0 0 1 11.16-2.75c5.19-.46 9.56.45 12.24 2.8z"
                                  opacity="1"
                                  data-original="#00bcd4"
                                ></path>
                                <path
                                  fill="#00838f"
                                  d="m54.16 17.76-2.75-5.31c-2.5-2.189-6.471-3.113-11.2-2.859 3.4.213 6.249 1.151 8.2 2.859l2.75 5.31c.36 3.34-1.03 7.28-3.81 11.24a41.473 41.473 0 0 1-7.98 8.3 53.4 53.4 0 0 1-6.87 4.69A54.546 54.546 0 0 1 25 45.6h-.01a41.551 41.551 0 0 1-11.16 2.75c-.355.031-.7.041-1.043.059 1.347.082 2.699.063 4.043-.059a41.551 41.551 0 0 0 11.16-2.75H28a54.546 54.546 0 0 0 7.5-3.61 53.4 53.4 0 0 0 6.87-4.69 41.473 41.473 0 0 0 7.98-8.3c2.78-3.96 4.17-7.9 3.81-11.24z"
                                  opacity="1"
                                  data-original="#00838f"
                                ></path>
                                <g fill="#ffdf00">
                                  <circle
                                    cx="3"
                                    cy="15"
                                    r="3"
                                    fill="#ffdf00"
                                    opacity="1"
                                    data-original="#ffdf00"
                                  ></circle>
                                  <circle
                                    cx="53"
                                    cy="43"
                                    r="3"
                                    fill="#ffdf00"
                                    opacity="1"
                                    data-original="#ffdf00"
                                  ></circle>
                                  <circle
                                    cx="3"
                                    cy="43"
                                    r="3"
                                    fill="#ffdf00"
                                    opacity="1"
                                    data-original="#ffdf00"
                                  ></circle>
                                  <circle
                                    cx="53"
                                    cy="15"
                                    r="3"
                                    fill="#ffdf00"
                                    opacity="1"
                                    data-original="#ffdf00"
                                  ></circle>
                                </g>
                                <path
                                  fill="#009688"
                                  d="M43 29c0 1.82-.09 3.6-.25 5.33-.1 1.01-.22 2-.38 2.97-1.09.88-2.24 1.73-3.45 2.55-1.09.74-2.23 1.46-3.42 2.14A54.546 54.546 0 0 1 28 45.6h-.01c-.49-.19-.99-.39-1.49-.61a55.021 55.021 0 0 1-6-3 53.4 53.4 0 0 1-6.87-4.69 54.99 54.99 0 0 1 0-16.6 53.4 53.4 0 0 1 6.87-4.69 55.148 55.148 0 0 1 6.01-3c.5-.22 1-.42 1.49-.61h.01a54.443 54.443 0 0 1 7.49 3.61c1.19.68 2.33 1.4 3.42 2.14 1.21.82 2.36 1.67 3.45 2.55.16.97.28 1.96.38 2.97.16 1.73.25 3.51.25 5.33z"
                                  opacity="1"
                                  data-original="#009688"
                                ></path>
                                <path
                                  fill="#00695c"
                                  d="M42.75 23.67c-.1-1.01-.22-2-.38-2.97-1.09-.88-2.24-1.73-3.45-2.55-1.09-.74-2.23-1.46-3.42-2.14a54.443 54.443 0 0 0-7.49-3.61H28c-.49.19-.99.39-1.49.61h-.008a55.785 55.785 0 0 1 6 3c1.19.68 2.33 1.4 3.42 2.14 1.21.82 2.36 1.67 3.45 2.55.16.97.28 1.96.38 2.97.16 1.73.25 3.51.25 5.33s-.09 3.6-.25 5.33c-.1 1.01-.22 2-.38 2.97-1.09.88-2.24 1.73-3.45 2.55-1.09.74-2.23 1.46-3.42 2.14a55.533 55.533 0 0 1-6.007 3h.007c.5.22 1 .42 1.49.61H28a54.546 54.546 0 0 0 7.5-3.61c1.19-.68 2.33-1.4 3.42-2.14 1.21-.82 2.36-1.67 3.45-2.55.16-.97.28-1.96.38-2.97.16-1.73.25-3.51.25-5.33s-.09-3.6-.25-5.33z"
                                  opacity="1"
                                  data-original="#00695c"
                                ></path>
                              </g>
                              <g fill="#000">
                                <path
                                  fill-rule="nonzero"
                                  d="M18.615 36.923a1 1 0 0 0 1.308-.538L21.333 33h5.334l1.41 3.385a1 1 0 0 0 1.846-.77l-5-12a1 1 0 0 0-1.846 0l-5 12a1 1 0 0 0 .538 1.308zM24 26.6l1.833 4.4h-3.666z"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></path>
                                <path
                                  d="M32 35a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2V25h2a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2h2v10z"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></path>
                                <path
                                  fill-rule="nonzero"
                                  d="M0 44a4 4 0 0 0 4 4 3.954 3.954 0 0 0 1.462-.286c2.364 1.81 5.7 2.754 9.8 2.754.618 0 1.26-.029 1.911-.071C20.077 56.331 24.267 60 29 60s8.923-3.669 11.828-9.6c.652.042 1.293.071 1.911.071 4.1 0 7.436-.944 9.8-2.754.465.186.96.282 1.461.283a4 4 0 0 0 2.185-7.343c.14-3.22-1.105-6.874-3.639-10.657 2.534-3.782 3.779-7.436 3.639-10.657a3.991 3.991 0 0 0-3.656-7.055c-2.717-2.079-6.729-3-11.7-2.676C37.927 3.673 33.735 0 29 0s-8.927 3.673-11.832 9.612c-4.969-.322-8.979.6-11.7 2.676a3.992 3.992 0 0 0-3.656 7.055C1.674 22.562 2.92 26.216 5.454 30c-2.534 3.783-3.78 7.437-3.639 10.657A3.993 3.993 0 0 0 0 44zm2 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm16.409-32.28c2.662.319 5.285.908 7.828 1.757a55.648 55.648 0 0 0-10.185 5.883 39.361 39.361 0 0 1 2.357-7.64zm23.538 7.64A55.571 55.571 0 0 0 37 16.143a58.074 58.074 0 0 0-5.228-2.666c2.54-.85 5.16-1.438 7.82-1.757a39.361 39.361 0 0 1 2.355 7.64zm-2.356 28.92a39.549 39.549 0 0 1-7.828-1.757 55.648 55.648 0 0 0 10.185-5.883 39.361 39.361 0 0 1-2.357 7.64zM36 17.876a52.707 52.707 0 0 1 6.45 4.377c.368 2.566.552 5.155.55 7.747a54.376 54.376 0 0 1-.549 7.747A52.739 52.739 0 0 1 36 42.124a53.749 53.749 0 0 1-7 3.398 53.7 53.7 0 0 1-7-3.4 52.707 52.707 0 0 1-6.45-4.377 54.934 54.934 0 0 1 0-15.494A52.739 52.739 0 0 1 22 17.876a53.749 53.749 0 0 1 7.006-3.4 53.7 53.7 0 0 1 6.994 3.4zm8.7 6.267A39.647 39.647 0 0 1 50.107 30a39.651 39.651 0 0 1-5.4 5.857c.196-1.946.294-3.901.293-5.857 0-1.956-.098-3.91-.295-5.857zM13.3 35.857A39.538 39.538 0 0 1 7.893 30a39.642 39.642 0 0 1 5.4-5.857 58.291 58.291 0 0 0 0 11.714zm7.706 8a58.074 58.074 0 0 0 5.228 2.666c-2.54.85-5.16 1.438-7.82 1.757a39.361 39.361 0 0 1-2.356-7.64A55.571 55.571 0 0 0 21 43.857zM29 58c-3.756 0-7.169-2.979-9.686-7.811A43.966 43.966 0 0 0 29 47.665a43.939 43.939 0 0 0 9.69 2.524C36.168 55.021 32.756 58 29 58zm25-12a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm.21-5.979c-.071 0-.138-.021-.21-.021a4 4 0 0 0-4 4c.004.894.31 1.76.869 2.459-2.178 1.437-5.357 2.12-9.165 1.977a43.434 43.434 0 0 0 2.619-9.626 43.722 43.722 0 0 0 6.977-7.066 16.744 16.744 0 0 1 2.91 8.277zM56 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-5.131-2.459A3.961 3.961 0 0 0 50 16a4 4 0 0 0 4 4c.072 0 .139-.017.21-.021a16.738 16.738 0 0 1-2.91 8.277 43.723 43.723 0 0 0-6.978-7.066 43.4 43.4 0 0 0-2.622-9.626c3.811-.144 6.992.536 9.169 1.977zM29 2c3.756 0 7.169 2.979 9.686 7.811a43.966 43.966 0 0 0-9.681 2.524 43.939 43.939 0 0 0-9.69-2.524C21.832 4.979 25.244 2 29 2zM4 14a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-.21 5.979c.071 0 .138.021.21.021a4 4 0 0 0 4-4 3.961 3.961 0 0 0-.869-2.459c2.177-1.437 5.356-2.119 9.165-1.977a43.434 43.434 0 0 0-2.619 9.626A43.756 43.756 0 0 0 6.7 28.255a16.728 16.728 0 0 1-2.91-8.276zM6.7 31.745a43.806 43.806 0 0 0 6.979 7.065c.5 3.299 1.38 6.53 2.621 9.627-3.806.144-6.987-.541-9.165-1.978A3.961 3.961 0 0 0 8 44a4 4 0 0 0-4-4c-.072 0-.139.018-.21.021a16.735 16.735 0 0 1 2.91-8.276z"
                                  fill="#000000"
                                  opacity="1"
                                  data-original="#000000"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco2} alt="Google Analytics" title="Google Analytics" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 512.07 512.07"
                        >
                          <g>
                            <path
                              d="M92.9 391.603v110.933H7.567V391.603c.028-9.414 7.652-17.039 17.067-17.067h51.2c9.414.028 17.039 7.653 17.066 17.067z"
                              transform="translate(1 1)"
                              fill="#fdd834"
                              data-original="#fdd834"
                            ></path>
                            <path
                              d="M67.3 391.603v110.933H7.567V391.603c.028-9.414 7.652-17.039 17.067-17.067h25.6c9.414.028 17.039 7.653 17.066 17.067z"
                              transform="translate(1 1)"
                              fill="#ffeb3a"
                              data-original="#ffeb3a"
                            ></path>
                            <path
                              d="M229.433 272.137v230.4H144.1v-230.4c.027-9.414 7.652-17.039 17.067-17.067h51.2c9.414.027 17.039 7.652 17.066 17.067z"
                              transform="translate(1 1)"
                              fill="#00838f"
                              data-original="#00838f"
                              class=""
                            ></path>
                            <path
                              d="M203.833 272.137v230.4H144.1v-230.4c.027-9.414 7.652-17.039 17.067-17.067h25.6c9.414.027 17.039 7.652 17.066 17.067z"
                              transform="translate(1 1)"
                              fill="#00bcd4"
                              data-original="#00bcd4"
                              class=""
                            ></path>
                            <path
                              d="M365.967 323.337v179.2h-85.333v-179.2c.027-9.414 7.652-17.039 17.067-17.067h51.2c9.413.027 17.038 7.652 17.066 17.067z"
                              transform="translate(1 1)"
                              fill="#558b30"
                              data-original="#558b30"
                            ></path>
                            <path
                              d="M340.367 323.337v179.2h-59.733v-179.2c.027-9.414 7.652-17.039 17.067-17.067h25.6c9.413.027 17.038 7.652 17.066 17.067z"
                              transform="translate(1 1)"
                              fill="#8bc34a"
                              data-original="#8bc34a"
                            ></path>
                            <path
                              d="M502.5 255.07v247.467h-85.333V255.07c.028-9.414 7.652-17.039 17.067-17.067h51.2c9.414.028 17.039 7.653 17.066 17.067z"
                              transform="translate(1 1)"
                              fill="#ad1457"
                              data-original="#ad1457"
                            ></path>
                            <path
                              d="M476.9 255.07v247.467h-59.733V255.07c.028-9.414 7.652-17.039 17.067-17.067h25.6c9.414.028 17.039 7.653 17.066 17.067z"
                              transform="translate(1 1)"
                              fill="#e91e63"
                              data-original="#e91e63"
                            ></path>
                            <g transform="translate(1 1)">
                              <circle
                                cx="50.233"
                                cy="212.403"
                                r="42.667"
                                fill="#ffeb3a"
                                data-original="#ffeb3a"
                              ></circle>
                              <circle
                                cx="186.767"
                                cy="50.27"
                                r="42.667"
                                fill="#ffeb3a"
                                data-original="#ffeb3a"
                              ></circle>
                              <circle
                                cx="459.833"
                                cy="67.337"
                                r="42.667"
                                fill="#ffeb3a"
                                data-original="#ffeb3a"
                              ></circle>
                              <circle
                                cx="323.3"
                                cy="152.67"
                                r="42.667"
                                fill="#ffeb3a"
                                data-original="#ffeb3a"
                              ></circle>
                            </g>
                            <path
                              d="M76.833 367.003h-51.2c-14.132.015-25.585 11.468-25.6 25.6v110.933a8.533 8.533 0 0 0 8.533 8.533H93.9a8.533 8.533 0 0 0 8.533-8.533V392.603c-.015-14.132-11.467-25.584-25.6-25.6zm8.534 128H17.1v-102.4a8.544 8.544 0 0 1 8.533-8.533h51.2a8.544 8.544 0 0 1 8.533 8.533v102.4zM213.367 247.537h-51.2c-14.132.015-25.585 11.468-25.6 25.6v230.4a8.533 8.533 0 0 0 8.533 8.533h85.333a8.533 8.533 0 0 0 8.533-8.533v-230.4c-.015-14.133-11.467-25.585-25.599-25.6zm8.533 247.466h-68.267V273.137a8.544 8.544 0 0 1 8.533-8.533h51.2a8.544 8.544 0 0 1 8.533 8.533v221.866zM349.9 298.737h-51.2c-14.132.015-25.585 11.468-25.6 25.6v179.2a8.533 8.533 0 0 0 8.533 8.533h85.333a8.533 8.533 0 0 0 8.533-8.533v-179.2c-.014-14.133-11.467-25.585-25.599-25.6zm8.533 196.266h-68.267V324.337a8.544 8.544 0 0 1 8.533-8.533h51.2a8.544 8.544 0 0 1 8.533 8.533v170.666zM486.433 230.47h-51.2c-14.132.015-25.585 11.468-25.6 25.6v247.467a8.533 8.533 0 0 0 8.533 8.533H503.5a8.533 8.533 0 0 0 8.533-8.533V256.07c-.015-14.132-11.467-25.585-25.6-25.6zm8.534 264.533H426.7V256.07a8.544 8.544 0 0 1 8.533-8.533h51.2a8.544 8.544 0 0 1 8.533 8.533v238.933zM460.833 17.137a51.16 51.16 0 0 0-47.319 70.708L362.52 119.72a50.96 50.96 0 0 0-73.432-3.123l-55.852-41.889c11.808-22.839 4.844-50.893-16.274-65.559s-49.837-11.394-67.115 7.647-17.751 47.942-1.108 67.54l-71.542 85.018c-22.94-13.498-52.397-7.167-67.766 14.564s-11.525 51.614 8.845 68.747 50.469 15.801 69.246-3.064 19.967-48.971 2.738-69.26l71.542-85.018c19.643 11.685 44.669 8.831 61.176-6.977l55.852 41.889c-10.87 21.055-5.868 46.819 12.091 62.277 17.959 15.458 44.181 16.568 63.383 2.684 19.202-13.884 26.365-39.132 17.314-61.031l50.994-31.875c15.633 17.597 41.254 22.258 62.083 11.296s31.493-34.72 25.84-57.569-26.164-38.895-49.702-38.88zm-409.6 230.4c-18.851 0-34.133-15.282-34.133-34.133s15.282-34.133 34.133-34.133 34.133 15.282 34.133 34.133c-.021 18.842-15.29 34.111-34.133 34.133zM187.767 85.403c-18.851 0-34.133-15.282-34.133-34.133s15.282-34.133 34.133-34.133S221.9 32.419 221.9 51.27c-.021 18.842-15.291 34.112-34.133 34.133zm136.533 102.4c-18.851 0-34.133-15.282-34.133-34.133s15.282-34.133 34.133-34.133c18.851 0 34.133 15.282 34.133 34.133-.021 18.842-15.291 34.112-34.133 34.133zm136.533-85.333c-18.851 0-34.133-15.282-34.133-34.133s15.282-34.133 34.133-34.133c18.851 0 34.133 15.282 34.133 34.133-.021 18.842-15.29 34.111-34.133 34.133z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco3} alt="Wordpress" title="Wordpress" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 447.674 447.674"
                        >
                          <g>
                            <path
                              d="M134.289 138.16h-24.722l67.399 190.521 37.732-107.825-29.254-82.696H159.36v-18.154h115.508v18.154h-27.049l67.398 190.521 24.227-69.234c31.781-88.702-26.048-116.333-26.048-136.129s16.048-35.843 35.843-35.843c1.071 0 2.111.058 3.13.153-33.541-31.663-78.768-51.08-128.534-51.08-65.027 0-122.306 33.146-155.884 83.458h66.336v18.154h.002zM36.548 223.837c0 71.704 40.302 133.986 99.483 165.458l-84.52-238.919c-9.628 22.556-14.963 47.385-14.963 73.461zM386.833 131.547c2.679 15.774 1.868 33.503-2.243 51.301h.745l-2.832 8.092c-1.678 5.843-3.791 11.82-6.191 17.693l-64.444 180.541c59.057-31.51 99.256-93.725 99.256-165.338 0-33.557-8.834-65.048-24.291-92.289z"
                              fill="#00769d"
                              data-original="#00769d"
                            ></path>
                            <path
                              d="M166.075 402.033c18.195 5.894 37.603 9.091 57.762 9.091 19.228 0 37.777-2.902 55.239-8.285l-54.784-154.862-58.217 154.056z"
                              fill="#00769d"
                              data-original="#00769d"
                            ></path>
                            <path
                              d="M382.113 65.56C339.836 23.283 283.625 0 223.836 0S107.837 23.283 65.56 65.56 0 164.047 0 223.837c0 59.789 23.283 115.999 65.56 158.276s98.488 65.56 158.277 65.56 115.999-23.283 158.277-65.56c42.277-42.277 65.56-98.488 65.56-158.276-.001-59.79-23.284-116-65.561-158.277zM223.836 431.883c-114.717 0-208.046-93.329-208.046-208.046S109.119 15.79 223.836 15.79s208.046 93.33 208.046 208.047-93.328 208.046-208.046 208.046z"
                              fill="#00769d"
                              data-original="#00769d"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco4} alt="SEO" title="SEO" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              fill="#969faa"
                              d="M47 62H17c0-1.1.45-2.1 1.17-2.83C18.9 58.45 19.9 58 21 58h22c2.21 0 4 1.79 4 4z"
                              opacity="1"
                              data-original="#969faa"
                            ></path>
                            <path
                              fill="#aab2bd"
                              d="M23 52h18v6H23z"
                              opacity="1"
                              data-original="#aab2bd"
                            ></path>
                            <path
                              fill="#ccd1d9"
                              d="M58 44v4c0 2.21-1.79 4-4 4H10c-2.21 0-4-1.79-4-4v-4z"
                              opacity="1"
                              data-original="#ccd1d9"
                            ></path>
                            <path
                              fill="#69d6f4"
                              d="M10 16h44a4 4 0 0 1 4 4v24H6V20a4 4 0 0 1 4-4z"
                              opacity="1"
                              data-original="#69d6f4"
                            ></path>
                            <path
                              fill="#e6e9ed"
                              d="M48 16v.02a2 2 0 0 1-2 2H36l-5.61 3.72c-.26.17-.55.26-.85.26-.85 0-1.54-.69-1.54-1.54v-2.44H18a2 2 0 0 1-2-2v-12c0-1.1.9-2 2-2h28c1.1 0 2 .9 2 2zM62 24v16H50V24h8z"
                              opacity="1"
                              data-original="#e6e9ed"
                            ></path>
                            <path
                              fill="#ff826e"
                              d="M42 33v7h-4V28h4zM30 26h4v14h-4zM26 30v10h-4V30z"
                              opacity="1"
                              data-original="#ff826e"
                            ></path>
                            <path
                              fill="#fcd770"
                              d="M9 26c3.87 0 7 3.13 7 7s-3.13 7-7 7a6.994 6.994 0 0 1-7-7c0-2.8 1.63-5.2 4-6.32.91-.44 1.92-.68 3-.68z"
                              opacity="1"
                              data-original="#fcd770"
                            ></path>
                            <circle
                              cx="9"
                              cy="33"
                              r="3"
                              fill="#ffeaa7"
                              opacity="1"
                              data-original="#ffeaa7"
                            ></circle>
                            <path
                              d="M24 13.023h-2c-.552 0-1-.449-1-1h-2c0 1.654 1.346 3 3 3h2c1.654 0 3-1.346 3-3s-1.346-3-3-3h-2a1.001 1.001 0 0 1 0-2h2c.552 0 1 .449 1 1h2c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3s1.346 3 3 3h2a1.001 1.001 0 0 1 0 2zM32 15.023h3v-2h-3c-.552 0-1-.449-1-1v-1h4v-2h-4v-1c0-.551.448-1 1-1h3v-2h-3c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3zM40 15.023h2c1.654 0 3-1.346 3-3v-4c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3zm-1-7c0-.551.448-1 1-1h2c.552 0 1 .449 1 1v4c0 .551-.448 1-1 1h-2c-.552 0-1-.449-1-1z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <path
                              d="M63 23h-4v-3c0-2.757-2.243-5-5-5h-5V4.023c0-1.654-1.346-3-3-3H18c-1.654 0-3 1.346-3 3V15h-5c-2.757 0-5 2.243-5 5v6.082C2.613 27.468 1 30.047 1 33s1.613 5.532 4 6.918V48c0 2.757 2.243 5 5 5h12v4h-1c-2.757 0-5 2.243-5 5v1h32v-1c0-2.757-2.243-5-5-5h-1v-4h12c2.757 0 5-2.243 5-5v-7h4zM17 4.023c0-.551.448-1 1-1h28c.552 0 1 .449 1 1v12c0 .551-.448 1-1 1H35.698l-5.865 3.888c-.333.224-.833-.046-.833-.448v-3.44H18c-.552 0-1-.449-1-1zM7 20c0-1.654 1.346-3 3-3h5.177A2.995 2.995 0 0 0 18 19.023h9v1.44a2.54 2.54 0 0 0 3.938 2.115l5.363-3.555H46c1.31 0 2.415-.85 2.823-2.023H54c1.654 0 3 1.346 3 3v3h-8v9h-6v-5h-6v12h-2V25h-6v14h-2V29h-6v3h-4.069c-.495-3.94-3.859-7-7.931-7-.692 0-1.359.097-2 .263zm32 19V29h2v10zm-6 0h-2V27h2zm-8 0h-2v-8h2zM3 33c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6zm42.829 28H18.171A3.006 3.006 0 0 1 21 59h22c1.304 0 2.416.836 2.829 2zM40 57H24v-4h16zm14-6H10c-1.654 0-3-1.346-3-3v-3h50v3c0 1.654-1.346 3-3 3zm3-8H7v-2.263A7.953 7.953 0 0 0 9 41c4.072 0 7.436-3.06 7.931-7H21v5h-2v2h26v-2h-2v-5h6v7h8zm4-4H51V25h10z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <circle
                              cx="28"
                              cy="48"
                              r="1"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></circle>
                            <circle
                              cx="32"
                              cy="48"
                              r="1"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></circle>
                            <circle
                              cx="36"
                              cy="48"
                              r="1"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></circle>
                            <path
                              d="M13 33c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4zm-6 0c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2zM53 27h6v2h-6zM53 31h6v2h-6zM53 35h6v2h-6z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco5} alt="Salesforce" title="Salesforce" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <path
                              d="M144.33 246.588a60.33 60.33 0 0 0-8.052-.688c-6.058-.075-8.635 2.149-8.617 2.146-1.787 1.261-2.653 3.142-2.653 5.738 0 1.655.301 2.948.89 3.856.386.604.548.832 1.712 1.761l.017.01c-.019-.006 2.653 2.096 8.692 1.732 4.252-.256 8.015-1.066 8.015-1.066h-.004v-13.489zM321.894 228.942c-3.913 0-6.683 1.335-8.504 4.12-1.833 2.803-2.766 6.792-2.766 11.871 0 5.08.928 9.106 2.766 11.928 1.825 2.796 4.609 4.158 8.504 4.158s6.69-1.373 8.541-4.177c1.854-2.839 2.802-6.843 2.803-11.918-.001-5.075-.938-9.062-2.803-11.862-1.844-2.771-4.628-4.12-8.541-4.12zM202.659 228.717c-3.894 0-6.664 1.523-8.485 4.308-1.213 1.824-1.988 4.175-2.407 6.995l21.165.004c-.201-2.729-.736-5.164-1.957-6.999-1.844-2.777-4.422-4.308-8.316-4.308z"
                              fill="#00a1e2"
                              data-original="#00a1e2"
                            ></path>
                            <path
                              d="M401.563 125.308a109.12 109.12 0 0 0-44.589 9.501c-15.804-28.032-45.153-46.846-79.018-46.846-25.399 0-48.389 10.648-64.908 27.844l.019.098a99.087 99.087 0 0 0-79.018-39.133c-54.936 0-99.525 44.401-99.525 99.338a98.968 98.968 0 0 0 8.184 39.509C17.196 230.669 0 258.514 0 290.497c0 47.6 38.192 86.355 85.415 86.355a84.844 84.844 0 0 0 17.572-1.828c12.981 35.182 46.658 60.204 86.355 60.204 38.004 0 70.646-23.142 84.662-56.065a80.348 80.348 0 0 0 35.37 8.128c30.102 0 56.536-16.744 70.364-41.391a111.489 111.489 0 0 0 21.824 2.163C462.52 348.063 512 298.207 512 236.686s-49.48-111.378-110.437-111.378zm-291.51 129.171c0 8.992-6.528 14.58-17.026 14.58-5.155 0-10.084-.809-15.314-3.574-.978-.566-1.955-1.07-2.916-1.767-.104-.148-.54-.324-.218-1.163l-.008-.015 2.07-5.757c.327-.986 1.08-.657 1.381-.475.57.348.992.658 1.731 1.09 6.115 3.864 11.757 3.895 13.527 3.895 4.553 0 7.394-2.428 7.394-5.683v-.177c0-3.537-4.365-4.884-9.407-6.434l-1.114-.347c-6.923-1.976-14.336-4.835-14.336-13.603v-.179c0-8.315 6.717-14.129 16.33-14.129l1.048-.004c5.644 0 11.1 1.637 15.051 4.045.359.215.709.63.51 1.182-.188.526-1.943 5.225-2.145 5.757-.371.984-1.39.325-1.39.325-3.443-1.901-8.824-3.405-13.339-3.405-4.064 0-6.698 2.164-6.698 5.099v.175c0 3.425 4.496 4.896 9.708 6.585l.901.292c6.886 2.164 14.261 5.192 14.261 13.508v.179zm43.067 11.57s-1.099.299-2.088.526a178.608 178.608 0 0 1-7.469 1.452 54.322 54.322 0 0 1-9.012.751c-2.897 0-5.531-.269-7.864-.802-2.352-.526-4.389-1.414-6.039-2.614a12.304 12.304 0 0 1-3.876-4.647c-.903-1.862-1.36-4.139-1.36-6.773 0-2.596.536-4.891 1.588-6.848a14.364 14.364 0 0 1 4.308-4.892c1.787-1.287 3.876-2.254 6.19-2.879 2.295-.62 4.76-.937 7.3-.937 1.863 0 3.424.043 4.628.132l.028.069s2.352.213 4.892.581v-1.255c0-3.95-.826-5.83-2.446-7.074-1.656-1.27-4.139-1.919-7.337-1.919 0 0-7.224-.094-12.925 3.011-.263.156-.487.244-.487.244s-.713.251-.975-.481l-2.107-5.644c-.32-.818.267-1.18.267-1.18 2.671-2.093 9.143-3.35 9.143-3.35 2.145-.431 5.738-.731 7.958-.731 5.926 0 10.498 1.373 13.621 4.102 3.134 2.728 4.722 7.149 4.722 13.095l.017 27.092c.001 0 .057.784-.677.971zm19.905.955c0 .497-.354.901-.85.901h-7.87c-.499 0-.852-.404-.852-.901v-63.342c0-.495.354-.896.852-.896h7.87c.497 0 .85.4.85.896v63.342zm49.187-20.409c-.081.765-.864.771-.864.771l-29.726-.022c.169 4.516 1.26 7.695 3.443 9.877 2.145 2.132 5.569 3.492 10.16 3.5 7.055.019 10.065-1.407 12.191-2.201 0 0 .82-.294 1.12.518l1.938 5.437c.389.917.077 1.234-.25 1.419-1.844 1.034-6.359 2.944-14.938 2.973-4.177.013-7.789-.587-10.78-1.744-3.01-1.167-5.512-2.822-7.469-4.948-1.938-2.107-3.39-4.646-4.29-7.544-.897-2.879-1.347-6.059-1.347-9.482 0-3.349.435-6.547 1.298-9.464.865-2.953 2.226-5.531 4.026-7.713 1.806-2.183 4.102-3.929 6.83-5.212 2.728-1.273 6.096-1.9 9.802-1.9a21.628 21.628 0 0 1 8.504 1.726c1.863.79 3.725 2.239 5.644 4.289 1.204 1.299 3.055 4.14 3.8 6.942l.021.006c1.905 6.676.919 12.456.887 12.772zm24.52 22.449c-5.155 0-10.084-.81-15.315-3.575-.978-.566-1.958-1.07-2.916-1.767-.107-.148-.544-.323-.222-1.162l-.023-.016 2.07-5.757c.303-.94 1.189-.595 1.379-.474.561.361.993.658 1.733 1.089 6.096 3.864 11.753 3.895 13.527 3.895 4.553 0 7.394-2.427 7.394-5.682v-.177c0-3.537-4.346-4.884-9.407-6.435l-1.112-.346c-6.923-1.976-14.336-4.836-14.336-13.603v-.179c0-8.316 6.716-14.13 16.33-14.13l1.05-.003c5.644 0 11.1 1.637 15.051 4.045.357.214.709.63.508 1.182-.169.526-1.927 5.225-2.126 5.757-.373.983-1.392.325-1.392.325-3.462-1.902-8.824-3.405-13.339-3.405-4.064 0-6.698 2.163-6.698 5.099v.175c0 3.424 4.496 4.896 9.708 6.585l.901.292c6.905 2.163 14.261 5.192 14.261 13.508v.177c.001 8.994-6.528 14.582-17.026 14.582zm51.947-40.126c-.171.894-.995.863-.995.863h-9.776l-6.686 37.833c-.702 3.911-1.578 7.268-2.608 9.971-1.041 2.729-2.128 4.729-3.857 6.638-1.599 1.771-3.407 3.078-5.484 3.829-2.064.745-4.553 1.129-7.285 1.129-1.304 0-2.696-.024-4.348-.414a22.169 22.169 0 0 1-2.711-.792c-.372-.134-.668-.597-.457-1.184.207-.595 1.955-5.401 2.201-6.032.303-.771 1.072-.478 1.072-.478.529.222.896.38 1.601.52.706.141 1.661.262 2.38.262 1.291 0 2.468-.158 3.492-.503 1.24-.416 1.958-1.129 2.717-2.098.783-1.001 1.419-2.38 2.07-4.22.66-1.864 1.257-4.325 1.778-7.316l6.655-37.145h-6.559c-.79.004-1.044-.365-.967-.956l1.106-6.171c.173-.897.995-.863.995-.863h6.737l.363-2.012c1.007-5.958 3.014-10.486 5.964-13.459 2.971-2.995 7.202-4.512 12.57-4.512 1.351-.015 2.701.09 4.034.312.991.173 1.97.405 2.933.696.211.083.779.364.546 1.034l-2.269 6.231c-.19.469-.32.755-1.287.459a17.983 17.983 0 0 0-1.518-.37 12.338 12.338 0 0 0-2.438-.247 10.322 10.322 0 0 0-3.185.459 6.16 6.16 0 0 0-2.485 1.547c-.741.743-1.616 1.825-2.081 3.166-1.089 3.143-1.52 6.479-1.567 6.694h9.488c.794-.004 1.046.365.969.956l-1.108 6.173zm43.308 25.441c-.865 2.916-2.203 5.475-3.989 7.62-1.787 2.145-4.064 3.86-6.735 5.079-2.672 1.22-5.832 1.84-9.388 1.84s-6.717-.62-9.407-1.84c-2.672-1.223-4.946-2.935-6.735-5.079-1.787-2.146-3.129-4.704-3.989-7.62-.856-2.897-1.291-6.058-1.291-9.426 0-3.367.435-6.528 1.291-9.426.865-2.916 2.205-5.475 3.989-7.619 1.787-2.145 4.064-3.868 6.735-5.117 2.69-1.248 5.832-1.882 9.407-1.882s6.735.63 9.407 1.882c2.69 1.241 4.946 2.973 6.735 5.117 1.787 2.145 3.125 4.703 3.989 7.619h-.019c.854 2.897 1.289 6.077 1.289 9.426 0 3.369-.435 6.529-1.289 9.426zm36.375-31.136.019-.122c-.282.809-1.729 4.871-2.239 6.228-.194.516-.512.865-1.084.801 0 0-1.703-.398-3.255-.398-1.349 0-2.692.188-3.989.561a9.026 9.026 0 0 0-3.669 2.201c-1.078 1.054-1.953 2.523-2.596 4.365-.653 1.862-.98 4.816-.98 7.789v22.2a.9.9 0 0 1-.899.9h-7.789a.902.902 0 0 1-.901-.9v-44.213c0-.497.357-.897.85-.897h7.601c.5 0 .852.4.852.897l.004 3.612c1.129-1.543 3.164-2.877 5.004-3.706 1.863-.836 3.932-1.464 7.657-1.23 1.938.12 4.461.652 4.967.845l.025.01a.803.803 0 0 1 .422 1.057zm37.495 43.354c-3.311 1.312-7.921 2.22-12.417 2.22-7.601 0-13.433-2.182-17.309-6.509-3.876-4.309-5.832-10.197-5.832-17.46 0-3.367.48-6.547 1.43-9.444.959-2.916 2.389-5.475 4.271-7.619 1.881-2.146 4.252-3.87 7.055-5.118 2.803-1.249 6.077-1.879 9.764-1.879 2.483 0 4.685.15 6.585.44 2.032.307 4.715 1.034 5.851 1.479.209.081.781.363.548 1.031-.826 2.333-1.394 3.856-2.164 5.982-.329.905-1.016.605-1.016.605-2.897-.906-5.663-1.326-9.275-1.326-4.327 0-7.601 1.468-9.727 4.29-2.154 2.859-3.354 6.585-3.368 11.552-.019 5.456 1.336 9.481 3.763 11.984 2.408 2.5 5.795 3.763 10.028 3.763 1.712 0 3.337-.115 4.797-.345 1.449-.226 2.809-.677 4.083-1.164 0 0 .832-.322 1.119.53h.007l2.164 5.945a.798.798 0 0 1-.357 1.043zm43.991-19.982c-.081.765-.864.771-.864.771l-29.726-.022c.169 4.516 1.26 7.695 3.443 9.877 2.145 2.132 5.55 3.492 10.159 3.5 7.055.019 10.065-1.407 12.191-2.201 0 0 .82-.294 1.118.518l1.938 5.437c.388.917.077 1.234-.252 1.419-1.844 1.034-6.359 2.944-14.938 2.973-4.158.013-7.789-.587-10.78-1.744-3.01-1.167-5.513-2.822-7.469-4.948-1.957-2.107-3.407-4.646-4.308-7.544-.892-2.879-1.345-6.059-1.345-9.482 0-3.349.437-6.547 1.302-9.464.865-2.953 2.222-5.531 4.026-7.713 1.806-2.183 4.101-3.929 6.829-5.212 2.728-1.273 6.096-1.9 9.802-1.9a21.628 21.628 0 0 1 8.504 1.726c1.863.79 3.725 2.239 5.644 4.289 1.204 1.299 3.053 4.14 3.8 6.942l.04.006c1.904 6.676.918 12.456.886 12.772z"
                              fill="#00a1e2"
                              data-original="#00a1e2"
                            ></path>
                            <path
                              d="M440.278 228.717c-3.894 0-6.666 1.523-8.485 4.308-1.215 1.824-1.988 4.175-2.407 6.995l21.165.004c-.199-2.729-.734-5.164-1.957-6.999-1.844-2.777-4.422-4.308-8.316-4.308z"
                              fill="#00a1e2"
                              data-original="#00a1e2"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco6} alt="CRM" title="CRM" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              fill="#e6e9ed"
                              d="M2 26v34c0 1.1.9 2 2 2h52c1.1 0 2-.9 2-2V26z"
                              opacity="1"
                              data-original="#e6e9ed"
                            ></path>
                            <path
                              fill="#92e626"
                              d="M18 40h10c0 5.52-4.48 10-10 10-2.76 0-5.26-1.12-7.07-2.93z"
                              opacity="1"
                              data-original="#b4dd7f"
                            ></path>
                            <path
                              fill="#037ba6"
                              d="M28 40H18l7.07-7.07A9.969 9.969 0 0 1 28 40z"
                              opacity="1"
                              data-original="#4fc1e9"
                            ></path>
                            <path
                              fill="#fcd770"
                              d="M25.07 32.93 18 40l-7.07-7.07C12.74 31.12 15.24 30 18 30s5.26 1.12 7.07 2.93z"
                              opacity="1"
                              data-original="#fcd770"
                            ></path>
                            <path
                              fill="#ff826e"
                              d="m18 40-7.07 7.07C9.12 45.26 8 42.76 8 40s1.12-5.26 2.93-7.07zM37 48h14v4H37zM37 38h14v4H37z"
                              opacity="1"
                              data-original="#ff826e"
                            ></path>
                            <path
                              fill="#fcd770"
                              d="M54 54v2c0 1.1-.9 2-2 2H36c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zM54 44v2c0 1.1-.9 2-2 2H36c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zM54 34v2c0 1.1-.9 2-2 2H36c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2z"
                              opacity="1"
                              data-original="#fcd770"
                            ></path>
                            <path
                              fill="#92e626"
                              d="M2 26v-6c0-1.1.9-2 2-2h22c0 2.21 1.79 4 4 4h4l3.33 4zM58 22v4H42v-4z"
                              opacity="1"
                              data-original="#b4dd7f"
                            ></path>
                            <path
                              fill="#ffa04e"
                              d="M62 6v12c0 2.21-1.79 4-4 4H42v4c-.01.54-.24 1.05-.6 1.4a2.032 2.032 0 0 1-3.01-.14L37.33 26 34 22h-4c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h28c2.21 0 4 1.79 4 4z"
                              opacity="1"
                              data-original="#f0d0b4"
                            ></path>
                            <path
                              d="M33 9c1.103 0 2 .897 2 2h2c0-2.206-1.794-4-4-4s-4 1.794-4 4v2c0 2.206 1.794 4 4 4s4-1.794 4-4h-2c0 1.103-.897 2-2 2s-2-.897-2-2v-2c0-1.103.897-2 2-2zM44 7h-5v10h2v-4h3c.551 0 1 .449 1 1v3h2v-3a2.98 2.98 0 0 0-.78-2c.48-.532.78-1.229.78-2 0-1.654-1.346-3-3-3zm-3 4V9h3c.551 0 1 .449 1 1s-.449 1-1 1zM54.279 13h-.558l-2-6H49v10h2v-5.838L52.279 15h3.442L57 11.162V17h2V7h-2.721zM13 21h2v2h-2zM5 21h2v2H5zM9 21h2v2H9zM52 31H36c-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3v2c-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3v2c-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3h16c1.654 0 3-1.346 3-3v-2c0-1.654-1.346-3-3-3v-2c1.654 0 3-1.346 3-3v-2c0-1.654-1.346-3-3-3v-2c1.654 0 3-1.346 3-3v-2c0-1.654-1.346-3-3-3zm1 23v2c0 .552-.449 1-1 1H36c-.551 0-1-.448-1-1v-2c0-.552.449-1 1-1h16c.551 0 1 .448 1 1zm-3-3H38v-2h12zm3-7v2c0 .552-.449 1-1 1H36c-.551 0-1-.448-1-1v-2c0-.552.449-1 1-1h16c.551 0 1 .448 1 1zm-3-3H38v-2h12zm3-5c0 .552-.449 1-1 1H36c-.551 0-1-.448-1-1v-2c0-.552.449-1 1-1h16c.551 0 1 .448 1 1z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <path
                              d="M58 1H30c-2.757 0-5 2.243-5 5v11H4c-1.654 0-3 1.346-3 3v40c0 1.654 1.346 3 3 3h52c1.654 0 3-1.346 3-3V22.899A5.009 5.009 0 0 0 63 18V6c0-2.757-2.243-5-5-5zM4 19h21.101A5.009 5.009 0 0 0 30 23h3.532l1.667 2H3v-5c0-.551.449-1 1-1zm52 42H4c-.551 0-1-.448-1-1V27h33.865l.754.905A3.035 3.035 0 0 0 39.957 29a3.04 3.04 0 0 0 2.847-2H57v33c0 .552-.449 1-1 1zM43 25v-2h14v2zm18-7c0 1.654-1.346 3-3 3H41v4.957a1.044 1.044 0 0 1-1.845.668L34.468 21H30c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3h28c1.654 0 3 1.346 3 3z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <path
                              d="M18 51c6.065 0 11-4.935 11-11s-4.935-11-11-11S7 33.935 7 40s4.935 11 11 11zm0-2a8.948 8.948 0 0 1-5.611-1.975L18.414 41h8.527c-.499 4.493-4.317 8-8.941 8zm7.025-14.611A8.956 8.956 0 0 1 26.941 39h-6.527zm-1.414-1.414L18 38.586l-5.611-5.611C13.929 31.742 15.878 31 18 31s4.071.742 5.611 1.975zm-12.636 1.414L16.586 40l-5.611 5.611C9.742 44.071 9 42.122 9 40s.742-4.071 1.975-5.611zM5 53h2v2H5zM9 53h22v2H9zM5 57h6v2H5zM13 57h18v2H13z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco7} alt="Testing" title="Testing" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <path
                              fill="#e6e2e6"
                              d="m374.224 366.668 28.356-28.356 40.23 40.23-28.356 28.355z"
                              opacity="1"
                              data-original="#e6e2e6"
                            ></path>
                            <path
                              fill="#ecdaec"
                              d="m374.224 366.668 28.356-28.356 40.23 40.23-28.356 28.355z"
                              opacity="1"
                              data-original="#ecdaec"
                            ></path>
                            <path
                              fill="#e2cbe2"
                              d="m374.225 366.667 13.498-13.498 40.23 40.23-13.499 13.498z"
                              opacity="1"
                              data-original="#e2cbe2"
                            ></path>
                            <path
                              fill="#f9f6f6"
                              d="M8 23c0-8.284 6.716-15 15-15h252.445l92.937 92.937V489c0 8.284-6.716 15-15 15H23c-8.284 0-15-6.716-15-15z"
                              opacity="1"
                              data-original="#f9f6f6"
                            ></path>
                            <path
                              fill="#ecdaec"
                              d="M353.382 486H23c-8.284 0-15-6.716-15-15v18c0 8.284 6.716 15 15 15h330.382c8.284 0 15-6.716 15-15v-18c0 8.284-6.716 15-15 15z"
                              opacity="1"
                              data-original="#ecdaec"
                            ></path>
                            <g fill="#e2cbe2">
                              <path
                                d="M290.445 100.937h77.937L275.445 8v77.937c0 8.284 6.716 15 15 15z"
                                fill="#e2cbe2"
                                opacity="1"
                                data-original="#e2cbe2"
                              ></path>
                              <path
                                d="M290.445 100.937h77.937L275.445 8v77.937c0 8.284 6.716 15 15 15z"
                                fill="#e2cbe2"
                                opacity="1"
                                data-original="#e2cbe2"
                              ></path>
                              <circle
                                cx="313.937"
                                cy="277.937"
                                r="124.484"
                                fill="#e2cbe2"
                                opacity="1"
                                data-original="#e2cbe2"
                              ></circle>
                            </g>
                            <path
                              fill="#dab9d8"
                              d="M401.961 347.961c-48.614 48.614-127.433 48.614-176.047 0-22.016-22.016-34.062-50.228-36.136-79.023-2.506 34.787 9.539 70.426 36.136 97.023 48.614 48.614 127.433 48.614 176.047 0 26.598-26.598 38.643-62.236 36.136-97.023-2.075 28.795-14.119 57.007-36.136 79.023z"
                              opacity="1"
                              data-original="#dab9d8"
                            ></path>
                            <circle
                              cx="313.937"
                              cy="277.937"
                              r="90.132"
                              fill="#ffc700"
                              opacity="1"
                              data-original="#ffe27a"
                            ></circle>
                            <path
                              fill="#bf8d00"
                              d="M377.67 323.67c-35.199 35.199-92.267 35.199-127.465 0-15.307-15.307-23.949-34.751-25.943-54.733-2.591 25.966 6.052 52.841 25.943 72.733 35.198 35.199 92.267 35.199 127.465 0 19.891-19.892 28.534-46.767 25.943-72.733-1.993 19.982-10.636 39.426-25.943 54.733z"
                              opacity="1"
                              data-original="#f9cf58"
                            ></path>
                            <path
                              fill="#5fc634"
                              d="M305.871 315.018c-3.96 0-7.923-1.483-10.985-4.461l-20.683-20.113c-6.24-6.068-6.38-16.045-.312-22.286 6.068-6.24 16.046-6.379 22.286-.312l9.4 9.141 28.24-28.958c6.077-6.231 16.056-6.355 22.287-.28 6.231 6.077 6.356 16.056.28 22.287l-39.229 40.225a15.708 15.708 0 0 1-11.284 4.757z"
                              opacity="1"
                              data-original="#98db7c"
                            ></path>
                            <path
                              fill="#42a818"
                              d="m356.385 252.036-39.229 40.225a15.715 15.715 0 0 1-11.284 4.757c-3.96 0-7.923-1.483-10.985-4.461l-20.683-20.113a15.841 15.841 0 0 1-1.937-2.289c-4.336 6.219-3.676 14.831 1.937 20.289l20.683 20.113a15.703 15.703 0 0 0 10.985 4.461c4.1 0 8.196-1.59 11.284-4.757l39.229-40.225c5.369-5.505 5.888-13.931 1.641-20.012a15.847 15.847 0 0 1-1.641 2.012z"
                              opacity="1"
                              data-original="#82d361"
                            ></path>
                            <path
                              fill="#ff4755"
                              d="m448.493 372.946-39.547 39.547 47.317 47.317c10.921 10.92 28.626 10.92 39.547 0 10.92-10.92 10.92-28.626 0-39.547z"
                              opacity="1"
                              data-original="#ff4755"
                            ></path>
                            <path
                              fill="#fc2b3a"
                              d="m469.748 446.295-47.302-47.302-13.5 13.5 47.317 47.317c10.92 10.92 28.626 10.92 39.546 0a27.917 27.917 0 0 0 5.582-7.963c-10.361 4.855-23.085 3.006-31.643-5.552z"
                              opacity="1"
                              data-original="#fc2b3a"
                            ></path>
                            <g fill="#98db7c">
                              <path
                                d="M101.373 197.403H68.562a9.276 9.276 0 0 1-9.276-9.276v-32.812a9.276 9.276 0 0 1 9.276-9.276h32.812a9.276 9.276 0 0 1 9.276 9.276v32.812a9.277 9.277 0 0 1-9.277 9.276zM101.373 302.565H68.562a9.276 9.276 0 0 1-9.276-9.276v-32.812a9.276 9.276 0 0 1 9.276-9.276h32.812a9.276 9.276 0 0 1 9.276 9.276v32.812a9.277 9.277 0 0 1-9.277 9.276zM101.373 409.862H68.562a9.276 9.276 0 0 1-9.276-9.276v-32.812a9.276 9.276 0 0 1 9.276-9.276h32.812a9.276 9.276 0 0 1 9.276 9.276v32.812a9.277 9.277 0 0 1-9.277 9.276z"
                                fill="#5fc634"
                                opacity="1"
                                data-original="#98db7c"
                              ></path>
                            </g>
                            <path
                              fill="#42a818"
                              d="M101.373 179.403H68.562a9.276 9.276 0 0 1-9.276-9.275v18a9.276 9.276 0 0 0 9.276 9.276h32.812a9.275 9.275 0 0 0 9.275-9.276v-18a9.276 9.276 0 0 1-9.276 9.275zM101.373 284.565H68.562a9.276 9.276 0 0 1-9.276-9.276v18a9.276 9.276 0 0 0 9.276 9.276h32.812a9.275 9.275 0 0 0 9.275-9.276v-18a9.276 9.276 0 0 1-9.276 9.276zM101.373 391.862H68.562a9.276 9.276 0 0 1-9.276-9.276v18a9.276 9.276 0 0 0 9.276 9.276h32.812a9.275 9.275 0 0 0 9.275-9.276v-18a9.276 9.276 0 0 1-9.276 9.276z"
                              opacity="1"
                              data-original="#82d361"
                            ></path>
                            <path
                              fill="#ecdaec"
                              d="M275.445 85.937v18c0 8.284 6.716 15 15 15h77.937v-18h-77.937c-8.284 0-15-6.716-15-15z"
                              opacity="1"
                              data-original="#ecdaec"
                            ></path>
                            <path
                              d="M306.01 322.648c6.337 0 12.264-2.498 16.689-7.034l39.311-40.304c8.972-9.2 8.786-23.984-.415-32.957-9.201-8.971-23.988-8.785-32.96.414l-23.061 23.642-4.04-3.928c-9.214-8.956-24-8.751-32.961.462-8.958 9.213-8.751 23.997.463 32.956l20.726 20.152a23.188 23.188 0 0 0 16.248 6.597zm-26.659-49.227c3.184-3.274 8.437-3.342 11.706-.163l9.419 9.159a7.517 7.517 0 0 0 10.62-.141l28.3-29.014c3.188-3.269 8.439-3.332 11.705-.148 3.268 3.187 3.333 8.437.148 11.704l-39.311 40.303c-3.038 3.249-8.572 3.318-11.697.156l-20.726-20.152c-3.271-3.182-3.346-8.433-.164-11.704z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <path
                              d="M247.915 327.763a7.517 7.517 0 0 0-12 9.052 99.058 99.058 0 0 0 8.997 10.337c18.479 18.477 43.048 28.652 69.181 28.652s50.701-10.175 69.18-28.652c18.48-18.476 28.656-43.042 28.656-69.171 0-26.13-10.177-50.695-28.656-69.171-38.147-38.141-100.214-38.14-138.361 0-26.007 26.003-35.21 63.936-24.017 98.996a7.519 7.519 0 0 0 9.445 4.874 7.514 7.514 0 0 0 4.874-9.444c-9.475-29.678-1.686-61.788 20.328-83.798 32.284-32.281 84.818-32.281 117.102 0 15.64 15.638 24.254 36.429 24.254 58.544s-8.614 42.906-24.254 58.544c-15.639 15.637-36.433 24.25-58.551 24.25-22.117 0-42.912-8.612-58.552-24.25a84.152 84.152 0 0 1-7.626-8.763z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <path
                              d="m501.66 415.271-47.415-47.409a7.518 7.518 0 0 0-10.63 0l-.29.29-18.247-18.244a132.027 132.027 0 0 0 21.012-63.562 7.516 7.516 0 0 0-7.028-7.973c-4.139-.252-7.711 2.886-7.974 7.027a117.075 117.075 0 0 1-34.102 75.462c-22.824 22.822-52.797 34.246-82.779 34.275-.038-.001-.075-.006-.114-.006h-.597c-29.82-.15-59.594-11.57-82.296-34.269-22.142-22.138-34.336-51.573-34.336-82.882s12.194-60.744 34.336-82.882c45.707-45.702 120.079-45.702 165.786 0 17.024 17.022 28.258 38.493 32.489 62.094.733 4.085 4.641 6.799 8.724 6.071a7.515 7.515 0 0 0 6.072-8.723c-4.776-26.637-17.451-50.867-36.656-70.07a131.796 131.796 0 0 0-31.449-23.271v-60.566a7.608 7.608 0 0 0-2.201-5.314l-93.13-93.118A7.615 7.615 0 0 0 275.519 0H22.547C10.115 0 0 10.113 0 22.544v63.163a7.515 7.515 0 0 0 7.516 7.515 7.515 7.515 0 0 0 7.516-7.515V22.544c0-4.144 3.371-7.515 7.516-7.515h245.458v70.575c0 12.431 10.115 22.544 22.547 22.544h70.584v46.245c-14.664-5.556-30.124-8.41-45.609-8.577-.074-.01-.146-.025-.223-.025h-167.8a7.516 7.516 0 1 0 0 15.03h105.226a131.728 131.728 0 0 0-29.979 21.525h-75.247a7.516 7.516 0 1 0 0 15.03h61.72c-12.268 15.891-20.652 34.193-24.665 53.73h-37.054a7.516 7.516 0 1 0 0 15.03h34.859a134.583 134.583 0 0 0-.529 11.846c0 3.264.119 6.51.352 9.733h-34.681a7.516 7.516 0 1 0 0 15.03h36.64c3.833 20.341 12.379 39.401 25.101 55.87h-61.741a7.515 7.515 0 1 0 0 15.03h75.275a131.714 131.714 0 0 0 29.931 21.49h-105.21a7.516 7.516 0 1 0 0 15.03h166.59a132.883 132.883 0 0 0 47.042-8.596v87.891c0 4.143-3.371 7.515-7.516 7.515H22.547c-4.144 0-7.516-3.371-7.516-7.515V115.77c0-4.15-3.365-7.515-7.516-7.515s-7.516 3.364-7.516 7.515v373.69C0 501.887 10.115 512 22.547 512H353.62c12.432 0 22.547-10.113 22.547-22.544v-94.697a131.272 131.272 0 0 0 9.867-5.804l18.243 18.24c-3.157 2.756-3.326 8.008-.291 10.918l47.416 47.41c13.227 13.785 37.031 13.784 50.257 0 13.788-13.226 13.787-37.027.001-50.252zM290.552 93.119c-4.144 0-7.516-3.371-7.516-7.515V25.657l67.471 67.462zm107.742 286.839a133.304 133.304 0 0 0 9.321-8.468 132.623 132.623 0 0 0 8.468-9.32l16.612 16.609-17.79 17.787zm92.737 74.937c-7.632 7.955-21.367 7.953-29 0l-42.102-42.096 29.001-28.997 42.102 42.096c7.954 7.633 7.955 21.365-.001 28.997z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <path
                              d="M68.204 204.803h32.88c9.27 0 16.812-7.54 16.812-16.808v-32.876c0-9.269-7.541-16.809-16.812-16.809h-32.88c-9.269 0-16.811 7.54-16.811 16.809v32.876c0 9.268 7.542 16.808 16.811 16.808zm-1.779-49.684c0-.981.799-1.779 1.779-1.779h32.88c.982 0 1.78.798 1.78 1.779v32.876c0 .981-.799 1.779-1.78 1.779h-32.88a1.78 1.78 0 0 1-1.779-1.779zM51.393 293.362c0 9.268 7.541 16.808 16.811 16.808h32.88c9.27 0 16.812-7.54 16.812-16.808v-32.876c0-9.268-7.541-16.808-16.812-16.808h-32.88c-9.269 0-16.811 7.54-16.811 16.808zm15.032-32.876c0-.981.799-1.779 1.779-1.779h32.88c.982 0 1.78.798 1.78 1.779v32.876c0 .981-.799 1.779-1.78 1.779h-32.88a1.78 1.78 0 0 1-1.779-1.779zM51.393 400.87c0 9.268 7.541 16.808 16.811 16.808h32.88c9.27 0 16.812-7.54 16.812-16.808v-32.876c0-9.269-7.541-16.809-16.812-16.809h-32.88c-9.269 0-16.811 7.54-16.811 16.809zm15.032-32.876c0-.981.799-1.779 1.779-1.779h32.88c.982 0 1.78.798 1.78 1.779v32.876c0 .981-.799 1.779-1.78 1.779h-32.88a1.78 1.78 0 0 1-1.779-1.779z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco8} alt="Security" title="Security" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 60 60"
                        >
                          <g>
                            <g fill="none">
                              <path
                                fill="#9ed26a"
                                d="M46 30c.05 8.837-7.073 16.04-15.91 16.09-8.836.05-16.04-7.072-16.09-15.909V30c0-.181 0-.373.011-.555a16 16 0 0 1 13.994-15.317A15.475 15.475 0 0 1 30 14h.171c8.77.094 15.83 7.23 15.829 16z"
                                opacity="1"
                                data-original="#9ed26a"
                              ></path>
                              <rect
                                width="14"
                                height="13"
                                x="23"
                                y="26"
                                fill="#e4e8eb"
                                rx="2"
                                opacity="1"
                                data-original="#e4e8eb"
                              ></rect>
                              <circle
                                cx="30"
                                cy="32"
                                r="2"
                                fill="#a9b0bb"
                                opacity="1"
                                data-original="#a9b0bb"
                              ></circle>
                              <path
                                fill="#b4df80"
                                d="M13 4c0 .334-.057.666-.17.98A3 3 0 1 1 10 1a2.976 2.976 0 0 1 2.83 2.02c.113.314.17.646.17.98zM53 4a3 3 0 0 1-5.83.98 2.91 2.91 0 0 1 0-1.96A3 3 0 0 1 53 4zM13 56c0 .334-.057.666-.17.98a3 3 0 1 1 0-1.96c.113.314.17.646.17.98zM53 56a3 3 0 0 1-5.83.98 2.91 2.91 0 0 1 0-1.96A3 3 0 0 1 53 56zM7 40c0 .334-.057.666-.17.98a3 3 0 1 1 0-1.96c.113.314.17.646.17.98zM7 20c0 .334-.057.666-.17.98a3 3 0 1 1 0-1.96c.113.314.17.646.17.98zM59 40a3 3 0 0 1-5.83.98 2.91 2.91 0 0 1 0-1.96A3 3 0 0 1 59 40zM59 20a3 3 0 0 1-5.83.98 2.91 2.91 0 0 1 0-1.96A3 3 0 0 1 59 20z"
                                opacity="1"
                                data-original="#b4df80"
                              ></path>
                              <path
                                fill="#89c053"
                                d="M46 30c-.004 8.835-7.165 15.996-16 16-.494.002-.988-.022-1.48-.07 8.199-.794 14.455-7.683 14.458-15.92.002-8.238-6.25-15.13-14.448-15.93.488-.057.979-.084 1.47-.08h.17c8.769.096 15.828 7.23 15.83 16z"
                                opacity="1"
                                data-original="#89c053"
                              ></path>
                              <path
                                fill="#cad0d7"
                                d="M37 28v9a2.006 2.006 0 0 1-2 2h-2a2.006 2.006 0 0 0 2-2v-9a2.006 2.006 0 0 0-2-2h2a2.006 2.006 0 0 1 2 2z"
                                opacity="1"
                                data-original="#cad0d7"
                              ></path>
                              <path
                                fill="#ffffff"
                                d="M25 26v-3a5 5 0 0 1 10 0v3h-2v-3a3 3 0 0 0-6 0v3z"
                                opacity="1"
                                data-original="#ffffff"
                              ></path>
                              <path
                                fill="#a9b0bb"
                                d="M30 37a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1z"
                                opacity="1"
                                data-original="#a9b0bb"
                              ></path>
                              <g fill="#4fc0e8">
                                <path
                                  d="M53.17 39.02a2.91 2.91 0 0 0 0 1.96.881.881 0 0 1-.17.02h-5.71a1.356 1.356 0 0 1-.29-.06c-.05-.02-.1-.04-.14-.06a.06.06 0 0 0-.04-.01c-.01-.01-.02-.03-.04-.04-.089-.06-.17-.13-.24-.21-.01-.02-.02-.03-.03-.05a1.4 1.4 0 0 1-.15-.3v-.04a.948.948 0 0 1-.05-.23c0-.04.02-.07.02-.11 0-.01.01-.03.01-.04.017-.119.054-.234.11-.34a.01.01 0 0 0 .01-.01 18.853 18.853 0 0 0 2.16-5.7 1 1 0 0 1 1.96.4 20.835 20.835 0 0 1-1.6 4.8H53a.881.881 0 0 1 .17.02zM22.97 48.16c.015.056.025.113.03.17V55a2.006 2.006 0 0 1-2 2h-8a.881.881 0 0 1-.17-.02 2.91 2.91 0 0 0 0-1.96A.881.881 0 0 1 13 55h8v-6.03a21.062 21.062 0 0 1-6.96-5.32 1 1 0 0 1 1.52-1.3 19.162 19.162 0 0 0 6.81 5.05c.132.059.251.144.35.25.02.01.02.03.03.04a.98.98 0 0 1 .18.27c.02.07.02.14.04.2zM34.98 10.6a1 1 0 0 1-1.18.78A19.282 19.282 0 0 0 30 11a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v8.05c1.074.043 2.144.166 3.2.37a1 1 0 0 1 .78 1.18zM10 31H1a1 1 0 0 1 0-2h8.04a21.047 21.047 0 0 1 1.01-5.57 1 1 0 1 1 1.9.62A19.045 19.045 0 0 0 11 30a1 1 0 0 1-1 1zM47.17 55.02a2.91 2.91 0 0 0 0 1.96.881.881 0 0 1-.17.02h-8a2.006 2.006 0 0 1-2-2v-6.67a.471.471 0 0 1 .04-.17 1.2 1.2 0 0 1 .03-.2.98.98 0 0 1 .18-.27.138.138 0 0 1 .03-.04.976.976 0 0 1 .35-.25 18.7 18.7 0 0 0 5.94-4.1A1 1 0 1 1 45 44.7a21.226 21.226 0 0 1-6 4.26V55h8a.881.881 0 0 1 .17.02zM6.83 20.98a2.91 2.91 0 0 0 0-1.96A.881.881 0 0 1 7 19h5.13a20.986 20.986 0 0 1 5.27-5.8 1 1 0 1 1 1.2 1.6 19.043 19.043 0 0 0-5.06 5.7.218.218 0 0 1-.04.05.8.8 0 0 1-.22.23.4.4 0 0 1-.15.1.672.672 0 0 1-.12.06.982.982 0 0 1-.29.05c-.01 0-.02.01-.03.01H7a.881.881 0 0 1-.17-.02zM13 40.94c-.094.03-.191.05-.29.06H7a.881.881 0 0 1-.17-.02 2.91 2.91 0 0 0 0-1.96A.881.881 0 0 1 7 39h4.02a20.835 20.835 0 0 1-1.6-4.8 1 1 0 0 1 1.96-.4 18.853 18.853 0 0 0 2.16 5.7c0 .006.004.01.01.01.056.106.093.221.11.34 0 .01.01.03.01.04 0 .04.02.07.02.11a.948.948 0 0 1-.05.23.06.06 0 0 1-.01.04c-.03.107-.077.208-.14.3a.219.219 0 0 0-.03.05c-.07.08-.151.15-.24.21a.078.078 0 0 0-.04.04c-.02 0-.03 0-.04.01-.04.02-.09.04-.14.06zM60 30a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1 19.009 19.009 0 0 0-2.54-9.5.01.01 0 0 0-.01-.01 1.042 1.042 0 0 1-.11-.34c0-.01-.01-.03-.01-.04 0-.04-.02-.07-.02-.11a.948.948 0 0 1 .05-.23v-.04a1.4 1.4 0 0 1 .15-.3c.01-.02.02-.03.03-.05.07-.08.151-.15.24-.21.02-.01.03-.03.04-.04h.03c.128-.065.267-.106.41-.12.02 0 .03-.01.05-.01H53a.881.881 0 0 1 .17.02 2.91 2.91 0 0 0 0 1.96.881.881 0 0 1-.17.02h-4.03a21.251 21.251 0 0 1 2 8H59a1 1 0 0 1 1 1zM12.83 4.98a2.91 2.91 0 0 0 0-1.96A.881.881 0 0 1 13 3h8a2.006 2.006 0 0 1 2 2v5.2c.914-.324 1.85-.585 2.8-.78a1 1 0 1 1 .4 1.96 18.763 18.763 0 0 0-3.79 1.2c-.13.057-.269.087-.41.09-.04 0-.07-.02-.1-.02a.785.785 0 0 1-.22-.05.938.938 0 0 1-.15-.06 1.431 1.431 0 0 1-.15-.11 1.063 1.063 0 0 1-.11-.09 1.039 1.039 0 0 1-.17-.24 1.567 1.567 0 0 1-.08-.31c0-.04-.02-.08-.02-.12V5h-8a.881.881 0 0 1-.17-.02zM34.98 49.4a1 1 0 0 1-.78 1.18 21.331 21.331 0 0 1-3.2.37V59a1 1 0 0 1-2 0v-8.05a21.331 21.331 0 0 1-3.2-.37 1 1 0 0 1 .4-1.96c2.509.5 5.091.5 7.6 0a1 1 0 0 1 1.18.78zM37.04 11.84a.526.526 0 0 1-.04-.17V5a2.006 2.006 0 0 1 2-2h8a.881.881 0 0 1 .17.02 2.91 2.91 0 0 0 0 1.96A.881.881 0 0 1 47 5h-8v6.04a21.226 21.226 0 0 1 6 4.26 1 1 0 0 1-.02 1.41.944.944 0 0 1-.7.29.976.976 0 0 1-.71-.3 18.7 18.7 0 0 0-5.94-4.1.976.976 0 0 1-.35-.25.138.138 0 0 1-.03-.04.98.98 0 0 1-.18-.27 1.2 1.2 0 0 1-.03-.2z"
                                  fill="#4fc0e8"
                                  opacity="1"
                                  data-original="#4fc0e8"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </li>
                    </ul>
                    <ul class="circle">
                      <li class="iconBlock">
                        <img
                          src={capabilitiesIco99}
                          alt="Shopify"
                          title="Shopify"
                          className="img-fluid"
                        />
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco10} alt="Mobile App Development" title="Mobile App Development" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 55 55"
                        >
                          <g>
                            <path
                              fill="#afa1fd"
                              d="M3.757 43.457h27.741l-.081 4.388s.03 2.264-3.804 3.09H6.634s-2.378-.46-2.877-3.352z"
                              opacity="1"
                              data-original="#afa1fd"
                            ></path>
                            <path
                              fill="#b9e013"
                              d="M16.166 19.019a4.711 4.711 0 0 1-4.719 4.713 4.71 4.71 0 0 1-4.713-4.713 4.714 4.714 0 0 1 4.713-4.713 4.716 4.716 0 0 1 4.72 4.713z"
                              opacity="1"
                              data-original="#b9e013"
                            ></path>
                            <path
                              fill="#ff614b"
                              d="M16.166 30.226a4.711 4.711 0 0 1-4.719 4.713 4.71 4.71 0 0 1-4.713-4.713 4.714 4.714 0 0 1 4.713-4.712 4.716 4.716 0 0 1 4.72 4.712z"
                              opacity="1"
                              data-original="#ff614b"
                            ></path>
                            <path
                              fill="#f7d01c"
                              d="m38.719 34.81 8.75 8.833c.64.672 1.242 1.709 1.3 2.635.087 1.391-1.105 2.735-2.497 2.813-1.391.079-2.727-1.122-2.798-2.513-.033-.65.252-1.383.864-1.607.652-.239 1.405.233 1.668.876.484 1.188-.366 3.333-1.658 3.679-.89.238-2.104-.125-2.752-.935l-6.531-10.663c1.475-.87 2.702-1.903 3.654-3.117z"
                              opacity="1"
                              data-original="#f7d01c"
                            ></path>
                            <path
                              fill="#afa1fd"
                              d="M51.762 11.02v8.18c0 .42-.32.76-.71.76h-16.22c-.39 0-.71-.34-.71-.76v-8.18c0-.41.32-.75.71-.75h16.22c.39 0 .71.34.71.75z"
                              opacity="1"
                              data-original="#afa1fd"
                            ></path>
                            <path
                              d="M13.785 8.647a.696.696 0 0 0 .695-.695c0-.384-.311-.683-.695-.683s-.683.3-.683.683c0 .384.3.695.683.695zM16.622 8.477h4.097a.523.523 0 1 0 0-1.045h-4.097a.523.523 0 1 0 0 1.045zM5.629 11.625h24.03a.523.523 0 1 0 0-1.045H5.629a.523.523 0 1 0 0 1.045zM5.629 42.694a.523.523 0 1 0 0 1.045h24.03a.523.523 0 1 0 0-1.045zM18.779 46.673h-2.302a.523.523 0 1 0 0 1.045h2.302a.523.523 0 1 0 0-1.045zM13.361 17.329a.523.523 0 0 0-.739-.02c-.394.373-1.213 1.339-1.74 1.91-.1-.095-.417-.39-.603-.571a.522.522 0 1 0-.73.748c.276.269.752.707.982.933a.523.523 0 0 0 .726.006c.469-.444 1.656-1.862 2.084-2.267.21-.2.219-.53.02-.74zM10.273 32.372c.398 0 .369-.24 1.279-1.268.27.298.57.637.914 1.026a.523.523 0 0 0 .782-.693c-.29-.328-.672-.761-.994-1.115.215-.245.456-.53.767-.926a.522.522 0 1 0-.823-.645c-.266.34-.479.594-.669.812-.24-.24-.513-.504-.896-.868a.522.522 0 1 0-.72.758c.396.377.673.645.916.889-.27.303-.562.646-.973 1.193a.523.523 0 0 0 .417.837z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <path
                              d="M39.508 34.86a11.661 11.661 0 0 0 1.924-4.42c.37-1.8.31-3.61-.16-5.37a.523.523 0 0 0-1.01.27c.43 1.6.48 3.25.14 4.89-1.196 5.873-6.946 9.51-12.66 8.33-5.78-1.18-9.52-6.85-8.34-12.63 1.363-6.62 8.49-10.376 14.72-7.68v-1.13a10.603 10.603 0 0 0-2.097-.583V7.94a4.413 4.413 0 0 0-4.413-4.402H7.642A4.408 4.408 0 0 0 3.238 7.94v39.11a4.413 4.413 0 0 0 4.404 4.412h19.97a4.418 4.418 0 0 0 4.413-4.412v-7.417c.997-.182 1.97-.487 2.894-.927l6.265 10.211c.942 1.174 3.014 1.7 4.232.603 2.004.539 3.994-1.253 3.877-3.274-.073-1.135-.792-2.276-1.45-2.974zm-8.53 12.19a3.371 3.371 0 0 1-3.366 3.367H7.642a3.366 3.366 0 0 1-3.358-3.367V7.94a3.36 3.36 0 0 1 3.358-3.357h19.97a3.366 3.366 0 0 1 3.367 3.357v8.445c-5.883-.554-11.384 3.417-12.597 9.335-1.3 6.35 2.81 12.57 9.15 13.87 1.271.254 2.373.284 3.447.187v7.273zM45.11 48.27c-.64-.37-1.084-1.031-1.117-1.714-.023-.504.22-1.126.709-1.126.331 0 .685.293.818.624.278.66-.03 1.62-.41 2.216zm1.034.302c.467-.865.732-1.993.343-2.915-.343-.858-1.359-1.535-2.327-1.176-1.525.565-1.745 3.169.148 4.517-.72.244-1.793-.092-2.27-.68L35.841 38.21a11.668 11.668 0 0 0 3.02-2.519L47.09 44c.658.699 1.113 1.607 1.159 2.311.065 1.127-.968 2.26-2.106 2.26z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                            <path
                              d="M38.382 19.96h-1.51c.89.75 1.66 1.66 2.26 2.69a.523.523 0 0 0 .9-.53c-.46-.79-1.02-1.51-1.65-2.16zM33.474 26.068a.523.523 0 0 0 0 .74l2.173 2.171-2.173 2.174a.523.523 0 1 0 .74.738l2.542-2.543a.522.522 0 0 0 0-.74l-2.543-2.541a.523.523 0 0 0-.74 0zM26.932 23.466a.523.523 0 0 0-.738.028l-2.447 2.634a.522.522 0 0 0 .028.739l2.635 2.446a.523.523 0 0 0 .711-.766l-2.252-2.09 2.091-2.252a.522.522 0 0 0-.028-.739zM31.22 22.873l-2.93 10.125a.522.522 0 1 0 1.005.29l2.93-10.124a.522.522 0 1 0-1.004-.291zM36.075 18.296c.269.1.571-.034.673-.305l.457-1.222h1.781c.138.352.276.703.412 1.055a.522.522 0 1 0 .976-.377c-.624-1.616-1.23-3.13-1.82-4.661a.524.524 0 0 0-.488-.334h-.003a.522.522 0 0 0-.487.34l-1.808 4.832a.523.523 0 0 0 .307.672zm2-3.856.503 1.284h-.983zM41.95 18.33a.523.523 0 0 0 .522-.523V16.59c.371.08.782.058 1.172-.08 1.527-.544 1.93-2.51.52-3.727-1.211-1.045-2.738-.374-2.738.425v4.6c0 .288.235.522.523.522zm.522-4.95c.079-.045.239-.08.396-.087.511.019 1.175.695 1.116 1.364-.065.727-.922 1.145-1.512.833zM46.435 18.33a.523.523 0 0 0 .523-.523V16.59c1.248.267 2.446-.63 2.553-1.841.114-1.291-1.033-2.462-2.12-2.5-.93-.015-1.479.539-1.479.959v4.6c0 .288.235.522.523.522zm.523-4.95c.666-.373 1.58.51 1.512 1.277-.064.72-.914 1.146-1.512.833z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco11} alt="Custom Application Development" title="Custom Application Development" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <rect
                              width="400"
                              height="304"
                              x="32"
                              y="88"
                              fill="#3397e8"
                              rx="32"
                              opacity="1"
                              data-original="#3397e8"
                            ></rect>
                            <rect
                              width="336"
                              height="272"
                              x="64"
                              y="24"
                              fill="#e9eef2"
                              rx="16"
                              opacity="1"
                              data-original="#e9eef2"
                              class="hovered-path"
                            ></rect>
                            <path
                              fill="#dadcde"
                              d="M400 88v192a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V88z"
                              opacity="1"
                              data-original="#dadcde"
                              class=""
                            ></path>
                            <path
                              fill="#e9eef2"
                              d="M432 328v32a32 32 0 0 1-32 32H64a32 32 0 0 1-32-32v-32zM320 456H144a32 32 0 0 0-32 32h240a32 32 0 0 0-32-32z"
                              opacity="1"
                              data-original="#e9eef2"
                              class="hovered-path"
                            ></path>
                            <path
                              fill="#dadcde"
                              d="M272 392h-80l-16 64h112z"
                              opacity="1"
                              data-original="#dadcde"
                              class=""
                            ></path>
                            <circle
                              cx="152"
                              cy="176"
                              r="56"
                              fill="#e9eef2"
                              opacity="1"
                              data-original="#e9eef2"
                              class="hovered-path"
                            ></circle>
                            <g fill="#7e8589">
                              <circle
                                cx="152"
                                cy="176"
                                r="24"
                                fill="#7e8589"
                                opacity="1"
                                data-original="#7e8589"
                                class=""
                              ></circle>
                              <path
                                d="M182.67 222.86a56.028 56.028 0 0 1-61.34 0 32 32 0 0 1 61.34 0zM240 120h48v48h-48zM240 200h48v48h-48z"
                                fill="#7e8589"
                                opacity="1"
                                data-original="#7e8589"
                                class=""
                              ></path>
                            </g>
                            <path
                              fill="#2978b8"
                              d="M452.33 296a79.349 79.349 0 0 0-6.06-14.27L464 264l-32-32-17.73 17.73a79.349 79.349 0 0 0-14.27-6.06V216h-48v27.67a79.349 79.349 0 0 0-14.27 6.06L320 232l-32 32 17.73 17.73a79.349 79.349 0 0 0-6.06 14.27H272v48h27.67a79.349 79.349 0 0 0 6.06 14.27L288 376l32 32 17.73-17.73a79.349 79.349 0 0 0 14.27 6.06V424h48v-27.67a79.349 79.349 0 0 0 14.27-6.06L432 408l32-32-17.73-17.73a79.349 79.349 0 0 0 6.06-14.27H480v-48z"
                              opacity="1"
                              data-original="#2978b8"
                            ></path>
                            <circle
                              cx="376"
                              cy="320"
                              r="56"
                              fill="#e9eef2"
                              opacity="1"
                              data-original="#e9eef2"
                              class="hovered-path"
                            ></circle>
                            <circle
                              cx="376"
                              cy="320"
                              r="24"
                              fill="#2978b8"
                              opacity="1"
                              data-original="#2978b8"
                            ></circle>
                            <circle
                              cx="96"
                              cy="56"
                              r="8"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></circle>
                            <circle
                              cx="128"
                              cy="56"
                              r="8"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></circle>
                            <circle
                              cx="160"
                              cy="56"
                              r="8"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></circle>
                            <path
                              d="M152 240a64 64 0 1 0-64-64 64.072 64.072 0 0 0 64 64zm0-16a47.711 47.711 0 0 1-20.42-4.572 23.958 23.958 0 0 1 40.84 0A47.711 47.711 0 0 1 152 224zm-16-48a16 16 0 1 1 16 16 16.019 16.019 0 0 1-16-16zm16-48a47.968 47.968 0 0 1 33.561 82.272 40.4 40.4 0 0 0-11.227-11.385 32 32 0 1 0-44.668 0 40.4 40.4 0 0 0-11.227 11.385A47.968 47.968 0 0 1 152 128zM240 176h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zm8-48h32v32h-32z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                            <path
                              d="M64 400h117.754l-12 48H144a40.045 40.045 0 0 0-40 40 8 8 0 0 0 8 8h240a8 8 0 0 0 8-8 40.045 40.045 0 0 0-40-40h-25.754l-12-48h18.44l13.657 13.657a8 8 0 0 0 11.314 0l13.653-13.652q2.316 1.062 4.69 1.989V424a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-22.006q2.372-.926 4.69-1.989l13.653 13.652a8 8 0 0 0 11.314 0l32-32a8 8 0 0 0 0-11.314l-13.652-13.652q1.062-2.316 1.989-4.691H480a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-22.006q-.926-2.375-1.989-4.691l13.652-13.652a8 8 0 0 0 0-11.314L440 228.686V120a40.068 40.068 0 0 0-32-39.195V40a24.028 24.028 0 0 0-24-24H80a24.028 24.028 0 0 0-24 24v40.805A40.068 40.068 0 0 0 24 120v240a40.045 40.045 0 0 0 40 40zm256 64a24.042 24.042 0 0 1 22.629 16H121.371A24.042 24.042 0 0 1 144 464zm-133.754-16 12-48h67.508l12 48zM408 216V97.376A24.039 24.039 0 0 1 424 120v108.686L412.69 240q-2.316-1.062-4.69-1.989zm-10.392 35.3a71.415 71.415 0 0 1 12.83 5.449 8 8 0 0 0 9.489-1.366L432 243.313 452.687 264l-12.075 12.073a8 8 0 0 0-1.365 9.489 71.4 71.4 0 0 1 5.449 12.83A8 8 0 0 0 452.33 304H472v32h-19.67a8 8 0 0 0-7.634 5.608 71.386 71.386 0 0 1-5.449 12.83 8 8 0 0 0 1.365 9.489L452.687 376 432 396.687l-12.073-12.074a8 8 0 0 0-9.489-1.366 71.415 71.415 0 0 1-12.83 5.449A8 8 0 0 0 392 396.33V416h-32v-19.67a8 8 0 0 0-5.608-7.634 71.415 71.415 0 0 1-12.83-5.449 8 8 0 0 0-9.489 1.366L320 396.687 299.313 376l12.075-12.073a8 8 0 0 0 1.365-9.489 71.386 71.386 0 0 1-5.449-12.83A8 8 0 0 0 299.67 336H280v-32h19.67a8 8 0 0 0 7.634-5.608 71.4 71.4 0 0 1 5.449-12.83 8 8 0 0 0-1.365-9.489L299.313 264 320 243.313l12.073 12.074a8 8 0 0 0 9.489 1.366 71.415 71.415 0 0 1 12.83-5.449A8 8 0 0 0 360 243.67V224h32v19.67a8 8 0 0 0 5.608 7.63zM72 40a8.009 8.009 0 0 1 8-8h304a8.009 8.009 0 0 1 8 8v40H72zm0 56h320v112h-40a8 8 0 0 0-8 8v22.006q-2.372.925-4.69 1.989l-13.653-13.652a8 8 0 0 0-11.314 0L296 244.686V200a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h44.686l-2.343 2.343a8 8 0 0 0 0 11.314L296 283.309q-1.062 2.316-1.989 4.691H80a8.009 8.009 0 0 1-8-8zm208 112v32h-32v-32zM40 120a24.039 24.039 0 0 1 16-22.624V280a24.028 24.028 0 0 0 24 24h184v16H40zm0 216h224v8a8 8 0 0 0 8 8h22.006q.926 2.373 1.989 4.691l-13.652 13.652a8 8 0 0 0 0 11.314l2.343 2.343H64a24.027 24.027 0 0 1-24-24z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                            <path
                              d="M312 320a64 64 0 1 0 64-64 64.072 64.072 0 0 0-64 64zm112 0a48 48 0 1 1-48-48 48.054 48.054 0 0 1 48 48z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                            <path
                              d="M344 320a32 32 0 1 0 32-32 32.036 32.036 0 0 0-32 32zm48 0a16 16 0 1 1-16-16 16.019 16.019 0 0 1 16 16zM320 128h48a8 8 0 0 0 0-16h-48a8 8 0 0 0 0 16zM320 160h48a8 8 0 0 0 0-16h-48a8 8 0 0 0 0 16zM320 192h48a8 8 0 0 0 0-16h-48a8 8 0 0 0 0 16zM176 256h-48a8 8 0 0 0 0 16h48a8 8 0 0 0 0-16z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco12} alt="IOT" title="IOT" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 511.996 511.996"
                        >
                          <g>
                            <path
                              d="M479.843 159.619h-88.172a823.453 823.453 0 0 0-6.257 2.504l-10.75 7.25-4.25 12 3 11.25 4.75 9.25 12.062 6.062 2.207.995h1.83c1.224 0 2.361.371 3.306 1.005h27.289l3.742 4.188v121s5.125 10 5.312 10.062c.133.044 3.345 1.691 5.202 2.645 6.29-4.468 10.398-11.806 10.398-20.109v-112.85a5.94 5.94 0 0 1 5.941-5.94h24.388c13.616 0 24.655-11.039 24.655-24.655v-.001c.002-13.617-11.036-24.656-24.653-24.656zM46.885 164.501H41.29l-9.133 15.747v154.25l9.566 11.5 5.162 1.497c6.025-4.495 9.927-11.678 9.927-19.773V184.274c0-8.095-3.902-15.278-9.927-19.773z"
                              fill="#ffe559"
                              data-original="#ffe559"
                            ></path>
                            <circle
                              cx="210.862"
                              cy="255.998"
                              r="116.346"
                              fill="#60b9fe"
                              data-original="#60b9fe"
                            ></circle>
                            <path
                              d="M164.515 255.998c0-52.06 34.194-96.129 81.346-110.985a116.296 116.296 0 0 0-35-5.361c-64.256 0-116.346 52.09-116.346 116.346s52.09 116.346 116.346 116.346c12.197 0 23.953-1.881 35-5.361-47.152-14.856-81.346-58.925-81.346-110.985z"
                              fill="#1ca8ff"
                              data-original="#1ca8ff"
                            ></path>
                            <path
                              d="M36.958 327.722V184.274c0-8.095 3.902-15.278 9.927-19.773a24.545 24.545 0 0 0-14.728-4.881c-13.617 0-24.655 11.038-24.655 24.655v143.448c0 13.616 11.038 24.655 24.655 24.655a24.543 24.543 0 0 0 14.728-4.881c-6.025-4.497-9.927-11.68-9.927-19.775zM429.661 327.722V214.871a5.94 5.94 0 0 0-5.941-5.94h-24.388c-13.617 0-24.655-11.039-24.655-24.655v-.001c0-13.616 11.038-24.655 24.655-24.655h-29.456c-13.616 0-24.655 11.039-24.655 24.655v.001c0 13.616 11.039 24.655 24.655 24.655h24.388a5.94 5.94 0 0 1 5.941 5.94v112.851c0 13.616 11.038 24.655 24.655 24.655a24.537 24.537 0 0 0 14.728-4.882c-6.025-4.494-9.927-11.678-9.927-19.773z"
                              fill="#fbc700"
                              data-original="#fbc700"
                            ></path>
                            <circle
                              cx="210.86"
                              cy="255.998"
                              r="116.346"
                              fill="none"
                              stroke="#000000"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              data-original="#000000"
                            ></circle>
                            <path
                              d="M210.86 211.489c34.304 0 66.177-9.54 92.637-25.88-21.252-27.926-54.836-45.958-92.637-45.958s-71.385 18.032-92.637 45.958c26.46 16.341 58.332 25.88 92.637 25.88zM210.86 300.507c34.304 0 66.177 9.54 92.637 25.88-21.252 27.926-54.836 45.958-92.637 45.958s-71.385-18.032-92.637-45.958c26.46-16.34 58.332-25.88 92.637-25.88z"
                              fill="none"
                              stroke="#000000"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              data-original="#000000"
                            ></path>
                            <ellipse
                              cx="210.86"
                              cy="255.998"
                              rx="64.364"
                              ry="116.346"
                              fill="none"
                              stroke="#000000"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              data-original="#000000"
                            ></ellipse>
                            <path
                              d="M210.86 142.118v227.761M96.979 255.998H324.74M310.673 58.169c-29.744-16.007-63.735-25.103-99.813-25.103s-70.069 9.096-99.813 25.103M287.198 84.941c-23.182-10.927-49.057-17.049-76.338-17.049-27.281 0-53.155 6.123-76.338 17.049M263.166 112.271c-16.271-6.168-33.899-9.555-52.306-9.555-18.407 0-36.034 3.387-52.306 9.555M310.673 453.827c-29.744 16.007-63.735 25.103-99.813 25.103s-70.069-9.096-99.813-25.103M287.198 427.056c-23.182 10.927-49.057 17.049-76.338 17.049-27.281 0-53.155-6.123-76.338-17.049M263.166 399.725c-16.271 6.168-33.899 9.555-52.306 9.555-18.407 0-36.034-3.387-52.306-9.555M407.358 159.619h-37.484c-13.617 0-24.655 11.039-24.655 24.655v.001c0 13.616 11.038 24.655 24.655 24.655h24.388a5.94 5.94 0 0 1 5.941 5.94v112.851c0 13.616 11.038 24.655 24.655 24.655h0c13.617 0 24.655-11.039 24.655-24.655v-112.85a5.94 5.94 0 0 1 5.941-5.94h24.388c13.617 0 24.655-11.039 24.655-24.655v-.001c0-13.616-11.038-24.655-24.655-24.655h-37.484M56.81 238.369v-54.094c0-13.616-11.038-24.655-24.655-24.655S7.5 170.658 7.5 184.275v143.448c0 13.616 11.038 24.655 24.655 24.655S56.81 341.34 56.81 327.723V273.37"
                              fill="none"
                              stroke="#000000"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              data-original="#000000"
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco13} alt="Digital Transformation" title="Digital Transformation" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <circle
                              cx="255.874"
                              cy="256.125"
                              r="103.064"
                              fill="#edf2fa"
                              data-original="#edf2fa"
                              class=""
                            ></circle>
                            <circle
                              cx="255.874"
                              cy="256.125"
                              r="65.996"
                              fill="#fea02c"
                              data-original="#fea02c"
                              class=""
                            ></circle>
                            <path
                              d="M255.982 359.191c-56.973 0-103.158-46.185-103.158-103.158s46.185-103.158 103.158-103.158V10.041h-44.837v38.872a210.64 210.64 0 0 0-70.126 29.059l-27.4-27.4-63.203 63.25 27.377 27.377a210.627 210.627 0 0 0-29.057 70.126H10.015v89.417h38.72a210.665 210.665 0 0 0 29.057 70.126l-27.377 27.377 63.203 63.25 27.4-27.4a210.63 210.63 0 0 0 70.126 29.059v38.823l44.837.025.001-142.811z"
                              fill="#ffb954"
                              data-original="#ffb954"
                            ></path>
                            <circle
                              cx="477.991"
                              cy="115.463"
                              r="23.999"
                              fill="#62cd4d"
                              data-original="#62cd4d"
                            ></circle>
                            <circle
                              cx="477.991"
                              cy="396.566"
                              r="23.999"
                              fill="#62cd4d"
                              data-original="#62cd4d"
                            ></circle>
                            <circle
                              cx="423.994"
                              cy="478.001"
                              r="23.999"
                              fill="#ff5d5d"
                              data-original="#ff5d5d"
                            ></circle>
                            <circle
                              cx="423.994"
                              cy="33.998"
                              r="23.999"
                              fill="#ff5d5d"
                              data-original="#ff5d5d"
                            ></circle>
                            <circle
                              cx="477.991"
                              cy="256.155"
                              r="23.999"
                              fill="#2e9de3"
                              data-original="#2e9de3"
                            ></circle>
                            <path
                              d="M205.655 128.402c5.138-2.027 7.658-7.835 5.631-12.972s-7.834-7.661-12.972-5.631c-29.005 11.447-53.76 31.094-71.586 56.818-18.254 26.338-27.901 57.259-27.901 89.416 0 5.523 4.478 9.999 9.999 9.999 5.522 0 9.999-4.477 9.999-9.999 0-56.715 34.083-106.813 86.83-127.631zM321.869 246.128c-5.522 0-9.999 4.477-9.999 9.999 0 30.876-25.119 55.997-55.997 55.997s-55.997-25.121-55.997-55.997 25.119-55.997 55.997-55.997c5.522 0 9.999-4.477 9.999-9.999s-4.478-9.999-9.999-9.999c-41.903 0-75.995 34.091-75.995 75.995s34.092 75.995 75.995 75.995 75.995-34.091 75.995-75.995c0-5.522-4.477-9.999-9.999-9.999zM348.937 255.75v.377c0 5.523 4.478 9.999 9.999 9.999s9.999-4.477 9.999-9.999v-.377c0-5.523-4.478-9.999-9.999-9.999s-9.999 4.476-9.999 9.999zM304.336 336.945a10.058 10.058 0 0 0-2.93 7.07c0 2.63 1.069 5.21 2.93 7.07a10.05 10.05 0 0 0 7.07 2.92c2.63 0 5.21-1.06 7.069-2.92a10.077 10.077 0 0 0 2.931-7.07c0-2.64-1.07-5.21-2.931-7.07a10.029 10.029 0 0 0-7.069-2.93 10.043 10.043 0 0 0-7.07 2.93zM477.987 362.569a33.776 33.776 0 0 0-15.906 3.963l-29.592-29.592a10.003 10.003 0 0 0-7.071-2.929h-72.914c-5.522 0-9.999 4.477-9.999 9.999s4.478 9.999 9.999 9.999h68.771l26.667 26.667a33.781 33.781 0 0 0-3.954 15.889c0 18.747 15.251 33.998 33.998 33.998s33.998-15.251 33.998-33.998-15.251-33.996-33.997-33.996zm0 47.997c-7.72 0-13.999-6.28-13.999-13.999s6.28-13.999 13.999-13.999c7.72 0 13.999 6.28 13.999 13.999s-6.281 13.999-13.999 13.999z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                            <path
                              d="M423.992 444.004c-4.756 0-9.285.985-13.399 2.757l-30.401-55.456a10 10 0 0 0-8.768-5.193H265.98v-26.921c0-5.523-4.478-9.999-9.999-9.999-51.368 0-93.158-41.79-93.158-93.158 0-50.746 40.787-92.139 91.299-93.134a9.993 9.993 0 0 0 1.751.163c38.701 0 73.766 24.36 87.255 60.615a10.002 10.002 0 0 0 9.372 6.516 9.994 9.994 0 0 0 3.486-.63c5.176-1.926 7.811-7.683 5.885-12.858-5.467-14.695-13.863-27.768-24.356-38.684h87.903c2.652 0 5.195-1.054 7.071-2.929l29.592-29.592a33.776 33.776 0 0 0 15.906 3.963c18.747 0 33.998-15.251 33.998-33.998s-15.251-33.998-33.998-33.998-33.998 15.251-33.998 33.998a33.771 33.771 0 0 0 3.955 15.89l-26.667 26.667H311.86c-13.901-7.949-29.512-12.998-45.878-14.483v-18.075h105.441a10 10 0 0 0 8.755-5.168l30.387-55.069a33.813 33.813 0 0 0 13.427 2.768c18.747 0 33.998-15.251 33.998-33.998S442.739 0 423.992 0s-33.998 15.251-33.998 33.998c0 6.556 1.87 12.679 5.097 17.877l-29.571 53.59h-99.538V10.041c0-5.523-4.478-9.999-9.999-9.999h-44.838c-5.522 0-9.999 4.477-9.999 9.999v30.943a219.704 219.704 0 0 0-58.662 24.311L120.688 43.5a9.996 9.996 0 0 0-14.144.003l-63.203 63.25c-3.903 3.906-3.902 10.234.002 14.138l21.771 21.772a219.74 219.74 0 0 0-24.309 58.662h-30.79c-5.522 0-9.999 4.477-9.999 9.999v89.417c0 5.523 4.478 9.999 9.999 9.999h30.792a219.654 219.654 0 0 0 24.309 58.661l-21.771 21.772c-3.904 3.904-3.905 10.232-.002 14.138l63.203 63.25a10.004 10.004 0 0 0 7.071 2.932h.002c2.652 0 5.195-1.054 7.071-2.929l21.795-21.794a219.784 219.784 0 0 0 58.661 24.311v30.894c0 5.521 4.474 9.996 9.993 9.999h44.843c2.651 0 5.194-1.028 7.069-2.902a10.003 10.003 0 0 0 2.931-7.073V406.11h99.52l29.601 53.995A33.785 33.785 0 0 0 389.995 478c0 18.747 15.251 33.998 33.998 33.998s33.998-15.251 33.998-33.998c0-18.745-15.252-33.996-33.999-33.996zm53.995-342.539c7.72 0 13.999 6.28 13.999 13.999s-6.28 13.999-13.999 13.999c-7.72 0-13.999-6.28-13.999-13.999s6.279-13.999 13.999-13.999zm-53.995-81.466c7.72 0 13.999 6.28 13.999 13.999s-6.28 13.999-13.999 13.999c-7.72 0-13.999-6.28-13.999-13.999s6.279-13.999 13.999-13.999zm-178.01 471.997-24.838-.014v-28.828a10 10 0 0 0-7.899-9.776c-23.822-5.118-46.296-14.431-66.799-27.681a10 10 0 0 0-12.498 1.328l-20.327 20.328-49.067-49.104 20.31-20.31a9.999 9.999 0 0 0 1.327-12.498c-13.249-20.503-22.562-42.976-27.678-66.798a10 10 0 0 0-9.776-7.9H20.014v-69.418h28.721a10 10 0 0 0 9.776-7.9c5.117-23.822 14.429-46.295 27.678-66.798a9.999 9.999 0 0 0-1.327-12.498l-20.31-20.31 49.067-49.104 20.327 20.328a10 10 0 0 0 12.498 1.328c20.502-13.249 42.976-22.563 66.799-27.681a10 10 0 0 0 7.899-9.776V20.041h24.839v123.274c-57.727 5.08-103.159 53.695-103.159 112.719s45.43 107.639 103.158 112.719l.002 123.243zm178.01.005c-7.72 0-13.999-6.28-13.999-13.999 0-7.72 6.28-13.999 13.999-13.999 7.72 0 13.999 6.28 13.999 13.999 0 7.72-6.281 13.999-13.999 13.999z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                            <path
                              d="M477.987 222.16c-15.268 0-28.215 10.117-32.495 23.999H415.99c-5.522 0-9.999 4.477-9.999 9.999 0 5.523 4.478 9.999 9.999 9.999h29.501c4.28 13.881 17.227 23.999 32.495 23.999 18.747 0 33.998-15.251 33.998-33.998.001-18.747-15.251-33.998-33.997-33.998zm0 47.997c-7.72 0-13.999-6.28-13.999-13.999 0-7.72 6.28-13.999 13.999-13.999 7.72 0 13.999 6.28 13.999 13.999s-6.281 13.999-13.999 13.999z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        {/* <img src={capabilitiesIco14} alt="Blockchain" title="Blockchain" className="img-fluid" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="42"
                          height="42"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <g fill-rule="evenodd">
                              <path
                                fill="#1176e8"
                                d="m427.491 165.548 73.502 42.436v84.872l-73.502 42.435-73.501-42.435v-84.872z"
                                opacity="1"
                                data-original="#1176e8"
                              ></path>
                              <path
                                fill="#4eb1fc"
                                d="m353.99 207.984 73.501 42.436v84.871l-73.501-42.435z"
                                opacity="1"
                                data-original="#4eb1fc"
                              ></path>
                              <path
                                fill="#2a92fa"
                                d="m427.491 250.42 73.502-42.436v84.872l-73.502 42.435z"
                                opacity="1"
                                data-original="#2a92fa"
                              ></path>
                              <path
                                fill="#f9ac00"
                                d="m84.494 165.548-73.502 42.436v84.872l73.502 42.435 73.501-42.435v-84.872z"
                                opacity="1"
                                data-original="#f9ac00"
                              ></path>
                              <path
                                fill="#fdc72e"
                                d="M157.995 207.984 84.494 250.42v84.871l73.501-42.435z"
                                opacity="1"
                                data-original="#fdc72e"
                              ></path>
                              <path
                                fill="#ffeb87"
                                d="m84.494 250.42-73.502-42.436v84.872l73.502 42.435z"
                                opacity="1"
                                data-original="#ffeb87"
                              ></path>
                              <path
                                fill="#29b933"
                                d="m255.992 309.131 73.501 42.436v84.872l-73.501 42.436-73.501-42.436v-84.872z"
                                opacity="1"
                                data-original="#29b933"
                                class=""
                              ></path>
                              <path
                                fill="#96ff96"
                                d="m182.491 351.567 73.501 42.436v84.872l-73.501-42.436z"
                                opacity="1"
                                data-original="#96ff96"
                                class=""
                              ></path>
                              <path
                                fill="#2dd62d"
                                d="m255.992 394.003 73.501-42.436v84.872l-73.501 42.436z"
                                opacity="1"
                                data-original="#2dd62d"
                              ></path>
                              <path
                                fill="#7986bf"
                                d="m342.493 105.273-17.394-3.43-7.639-18.415 9.881-14.734-20.368-20.368-14.734 9.882-18.415-7.639-3.43-17.394h-28.803l-3.43 17.394-18.415 7.639-14.734-9.882-20.368 20.368 9.881 14.734-7.638 18.415-17.395 3.43v28.804l17.395 3.43 7.638 18.415-9.881 14.734 20.368 20.367 14.734-9.881 18.415 7.639 3.43 17.394h28.803l3.43-17.394 18.415-7.639 14.734 9.881 20.368-20.367-9.881-14.734 7.639-18.415 17.394-3.43z"
                                opacity="1"
                                data-original="#7986bf"
                              ></path>
                              <path
                                fill="#909cd1"
                                d="m334.084 134.077-17.394 3.43-7.638 18.415 9.881 14.734-16.993 16.992-12.915-8.661-23.609 9.794-3.43 17.394h-20.395l-3.43-17.394-23.61-9.793-12.915 8.66-16.992-16.992 9.881-14.734-7.638-18.415-17.395-3.43v-28.804l17.395-3.43 7.638-18.415-9.881-14.734 16.992-16.992 12.915 8.66 23.61-9.793 3.43-17.394h20.395l3.43 17.394 23.609 9.793 12.915-8.66 16.993 16.992-9.881 14.734 7.638 18.415 17.394 3.43z"
                                opacity="1"
                                data-original="#909cd1"
                                class=""
                              ></path>
                            </g>
                            <circle
                              cx="248.961"
                              cy="119.675"
                              r="44.498"
                              fill="#7986bf"
                              opacity="1"
                              data-original="#7986bf"
                            ></circle>
                            <circle
                              cx="255.992"
                              cy="119.675"
                              r="44.32"
                              fill="#f3f3ff"
                              transform="rotate(-87.14 255.92 119.648)"
                              opacity="1"
                              data-original="#f3f3ff"
                            ></circle>
                            <path
                              fill-rule="evenodd"
                              d="M77.514 118.241V64.772c0-3.866 3.133-6.998 6.989-6.998h53.454c3.856 0 6.989 3.133 6.989 6.998s-3.133 7.003-6.989 7.003H91.492v46.465c0 3.866-3.133 6.999-6.989 6.999s-6.989-3.133-6.989-6.999zm289.492-53.469c0-3.866 3.133-6.998 7.037-6.998h53.454c3.856 0 6.989 3.133 6.989 6.998v53.469c0 3.866-3.133 6.999-6.989 6.999s-6.989-3.133-6.989-6.999V71.776h-46.465c-3.904 0-7.037-3.138-7.037-7.003zm-222.06 371.673c0 3.856-3.133 6.999-6.989 6.999H84.503c-3.856 0-6.989-3.143-6.989-6.999v-53.474c0-3.866 3.133-6.998 6.989-6.998s6.989 3.133 6.989 6.998v46.47h46.465c3.856 0 6.989 3.133 6.989 7.003zm289.54-53.474v53.474c0 3.856-3.133 6.999-6.989 6.999h-53.454c-3.904 0-7.037-3.143-7.037-6.999s3.133-7.003 7.037-7.003h46.465v-46.47c0-3.866 3.133-6.998 6.989-6.998s6.989 3.133 6.989 6.998zm0-59.807v-68.705l59.527-34.352v68.705zm-37.693-55.03c-1.928-3.345-6.218-4.492-9.544-2.559l-26.269 15.159v-60.627l59.528 34.352v68.705l-52.538-30.313 26.269-15.149c3.374-1.937 4.483-6.218 2.555-9.568zM259.47 303.065l31.427 18.138 56.105-32.391v-80.827c0-2.502 1.301-4.81 3.47-6.064l27.812-16.036-52.683-30.39 7.568 11.289c1.88 2.776 1.542 6.488-.819 8.849l-20.389 20.379c-2.362 2.367-6.073 2.728-8.869.863l-11.616-7.799-11.472 4.772-2.747 13.728c-.627 3.282-3.519 5.649-6.845 5.649h-28.824c-3.326 0-6.218-2.366-6.893-5.649l-2.699-13.728-11.471-4.772-11.665 7.799c-2.747 1.865-6.459 1.504-8.82-.863l-20.389-20.379c-2.362-2.362-2.699-6.073-.867-8.849l7.567-11.293-52.635 30.395 27.763 16.036a7.016 7.016 0 0 1 3.519 6.064v80.827l56.105 32.391 31.378-18.138c2.169-1.253 4.868-1.253 6.989 0zm3.519 163.688v-68.709l59.479-34.352v68.7l-59.479 34.362zm-73.505-103.062 59.527 34.352v68.709l-59.527-34.362v-68.7zm125.996-12.127-59.479 34.357-59.527-34.357 59.527-34.352zm-223.987-28.4v-68.705l59.479-34.352v60.627l-26.221-15.159c-3.374-1.933-7.664-.785-9.592 2.559-1.928 3.35-.771 7.63 2.603 9.568l26.221 15.149zM17.986 220.108l59.528 34.352v68.705l-59.528-34.352zm66.517-46.48 59.479 34.357-59.479 34.352-59.528-34.352zm91.918-62.607 11.761-2.318c2.314-.453 4.242-2.024 5.109-4.188l7.664-18.427a6.833 6.833 0 0 0-.675-6.579l-6.652-9.963 12.243-12.238 9.978 6.681a6.942 6.942 0 0 0 6.555.65l18.413-7.64c2.169-.897 3.76-2.815 4.193-5.114l2.314-11.756h17.304l2.361 11.756c.434 2.299 2.025 4.217 4.145 5.114l18.461 7.64a6.942 6.942 0 0 0 6.555-.65l9.977-6.681 12.243 12.238-6.7 9.963a6.957 6.957 0 0 0-.627 6.579l7.616 18.427a7.086 7.086 0 0 0 5.109 4.188l11.761 2.318v17.309l-11.761 2.318a7.088 7.088 0 0 0-5.109 4.184l-7.616 18.427a6.95 6.95 0 0 0 .627 6.579l6.7 9.963-12.243 12.243-9.977-6.68a6.946 6.946 0 0 0-6.555-.656l-18.461 7.645c-2.121.896-3.711 2.815-4.145 5.114l-2.361 11.756h-17.304l-2.314-11.756c-.434-2.299-2.024-4.218-4.193-5.114l-18.413-7.645a6.943 6.943 0 0 0-6.555.656l-9.978 6.68-12.243-12.243 6.652-9.963a6.83 6.83 0 0 0 .675-6.579l-7.664-18.427c-.868-2.159-2.795-3.731-5.109-4.184l-11.761-2.318zm251.076 62.607-59.528 34.357 59.528 34.352 59.479-34.352zm76.976 28.294-73.505-42.435a6.967 6.967 0 0 0-6.989 0l-31.716 18.316-59.913-34.579 11.52-2.27c3.278-.646 5.688-3.523 5.688-6.869v-28.819c0-3.345-2.41-6.223-5.688-6.869l-13.689-2.704-4.772-11.5 7.76-11.626c1.88-2.781 1.542-6.488-.819-8.85l-20.389-20.379c-2.362-2.367-6.073-2.728-8.869-.863l-11.616 7.794-11.472-4.772-2.747-13.723c-.627-3.282-3.519-5.649-6.845-5.649h-28.824c-3.326 0-6.218 2.367-6.893 5.649l-2.699 13.723-11.471 4.772-11.665-7.794c-2.747-1.865-6.459-1.504-8.82.863l-20.389 20.379c-2.362 2.362-2.699 6.069-.867 8.85l7.808 11.626-4.772 11.496-13.737 2.709a6.996 6.996 0 0 0-5.639 6.869v28.819a6.997 6.997 0 0 0 5.639 6.869l11.52 2.27-59.865 34.579-31.764-18.316c-2.121-1.253-4.82-1.253-6.989 0L7.479 201.922c-2.169 1.253-3.47 3.562-3.47 6.064v84.866c0 2.502 1.301 4.81 3.47 6.064l73.505 42.436c1.109.622 2.314.94 3.519.94s2.41-.318 3.47-.94l70.035-40.416 49.068 28.352-28.101 16.214c-2.169 1.253-3.471 3.562-3.471 6.064v84.881c0 2.497 1.301 4.81 3.471 6.059l73.505 42.431c1.109.626 2.314.94 3.519.94s2.41-.313 3.47-.94l73.506-42.431a7.008 7.008 0 0 0 3.519-6.059v-84.881c0-2.502-1.35-4.81-3.519-6.064l-28.053-16.214 49.068-28.352 69.987 40.416c1.109.622 2.314.94 3.519.94s2.41-.318 3.47-.94l73.505-42.436a7.016 7.016 0 0 0 3.519-6.064v-84.866c0-2.502-1.35-4.81-3.519-6.064zM256 82.288c20.63 0 37.355 16.774 37.355 37.384S276.629 157.056 256 157.056s-37.403-16.769-37.403-37.384S235.371 82.288 256 82.288zm0 88.771c-28.342 0-51.382-23.049-51.382-51.386S227.658 68.291 256 68.291s51.382 23.05 51.382 51.382-23.04 51.386-51.382 51.386z"
                              fill="#000000"
                              opacity="1"
                              data-original="#000000"
                              class=""
                            ></path>
                          </g>
                        </svg>
                      </li>
                      <li class="iconBlock">
                        <img
                          src={capabilitiesIco77}
                          alt="Zoho"
                          title="Zoho"
                          className="img-fluid"
                        />
                      </li>
                      <li class="iconBlock">
                        <img
                          src={capabilitiesIco88}
                          alt="AWS"
                          title="AWS"
                          className="img-fluid"
                        />
                      </li>
                    </ul>
                    <div class="centerLogo">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="100"
                        height="100"
                        x="0"
                        y="0"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <path
                            fill="#f9f7f8"
                            d="M324.029 512H34.252c-16.815 0-30.446-13.631-30.446-30.446V68.503c0-16.815 13.631-30.446 30.446-30.446h289.777c16.815 0 30.446 13.631 30.446 30.446v413.051c0 16.815-13.632 30.446-30.446 30.446z"
                            opacity="1"
                            data-original="#f9f7f8"
                          ></path>
                          <path
                            fill="#efedef"
                            d="M324.029 38.057h-30.446c16.815 0 30.446 13.631 30.446 30.446v413.051c0 16.815-13.631 30.446-30.446 30.446h30.446c16.815 0 30.446-13.631 30.446-30.446V68.503c0-16.814-13.632-30.446-30.446-30.446zM56.155 76.115a7.61 7.61 0 0 1-7.611-7.611V7.611C48.543 3.407 51.95 0 56.155 0s7.611 3.407 7.611 7.611v60.892a7.61 7.61 0 0 1-7.611 7.612zM117.047 76.115a7.61 7.61 0 0 1-7.611-7.611V7.611c0-4.204 3.407-7.611 7.611-7.611s7.611 3.407 7.611 7.611v60.892a7.61 7.61 0 0 1-7.611 7.612zM177.939 76.115a7.61 7.61 0 0 1-7.611-7.611V7.611c0-4.204 3.407-7.611 7.611-7.611s7.611 3.407 7.611 7.611v60.892a7.61 7.61 0 0 1-7.611 7.612zM238.831 76.115a7.61 7.61 0 0 1-7.611-7.611V7.611c0-4.204 3.407-7.611 7.611-7.611s7.611 3.407 7.611 7.611v60.892a7.61 7.61 0 0 1-7.611 7.612z"
                            opacity="1"
                            data-original="#efedef"
                          ></path>
                          <path
                            fill="#efedef"
                            d="M299.722 76.115a7.61 7.61 0 0 1-7.611-7.611V7.611c0-4.204 3.407-7.611 7.611-7.611s7.612 3.407 7.612 7.611v60.892a7.61 7.61 0 0 1-7.612 7.612z"
                            opacity="1"
                            data-original="#efedef"
                          ></path>
                          <g fill="#00516a">
                            <circle
                              cx="56.154"
                              cy="83.726"
                              r="15.223"
                              fill="#00516a"
                              opacity="1"
                              data-original="#00516a"
                            ></circle>
                            <circle
                              cx="117.046"
                              cy="83.726"
                              r="15.223"
                              fill="#00516a"
                              opacity="1"
                              data-original="#00516a"
                            ></circle>
                            <circle
                              cx="177.938"
                              cy="83.726"
                              r="15.223"
                              fill="#00516a"
                              opacity="1"
                              data-original="#00516a"
                            ></circle>
                            <circle
                              cx="238.83"
                              cy="83.726"
                              r="15.223"
                              fill="#00516a"
                              opacity="1"
                              data-original="#00516a"
                            ></circle>
                            <circle
                              cx="299.722"
                              cy="83.726"
                              r="15.223"
                              fill="#00516a"
                              opacity="1"
                              data-original="#00516a"
                            ></circle>
                          </g>
                          <path
                            fill="#fd4755"
                            d="M306.799 355.215c-.454.451-.938.868-1.449 1.248-1.02.76-3.403.569-4.599 1.017l-60.172 22.382c-3.789 1.42-6.063-1.138-4.581-4.893l23.632-61.213c.098-.247.138-1.682.249-1.923a13.546 13.546 0 0 1 2.74-3.904l165.782-165.782 33.106-25.071c6.37-6.37 13.576-8.215 19.722-1.629l22.45 23.046c6.068 6.51 1.35 12.514-4.966 18.784l-24.581 30.602z"
                            opacity="1"
                            data-original="#fd4755"
                          ></path>
                          <path
                            fill="#fb2b3a"
                            d="m503.68 138.494-22.45-23.046c-6.146-6.586-16.622-9.506-22.992-3.137l-3.972 3.972 19.646 19.646c6.068 6.51 4.535 17.238-1.78 23.508L276.353 355.215a13.553 13.553 0 0 1-4.789 3.071l-35.277 13.22-.288 3.464c-1.483 3.754 1.728 6.711 5.517 5.291l59.235-22.78c1.197-.448 3.58-.257 4.6-1.017.51-.38.995-.797 1.449-1.248L474.134 187.88l24.58-30.602c6.316-6.27 11.035-12.275 4.966-18.784z"
                            opacity="1"
                            data-original="#fb2b3a"
                          ></path>
                          <path
                            fill="#fe99a0"
                            d="M278.422 345.22a7.613 7.613 0 0 1-5.383-12.994l172.721-172.72a7.613 7.613 0 0 1 10.765 10.765l-172.721 172.72a7.587 7.587 0 0 1-5.382 2.229z"
                            opacity="1"
                            data-original="#fe99a0"
                          ></path>
                          <path
                            fill="#ffdfcf"
                            d="m305.341 356.449-16.625-4.545a3.161 3.161 0 0 1-2.215-2.216l-3.853-14.095a3.163 3.163 0 0 0-2.215-2.216l-14.095-3.852a3.16 3.16 0 0 1-2.215-2.215l-4.227-15.469c-.112.241-.233.477-.331.724l-24.716 62.58c-1.483 3.754 2.201 7.483 5.991 6.063l61.169-22.923a13.5 13.5 0 0 0 3.332-1.836z"
                            opacity="1"
                            data-original="#ffdfcf"
                          ></path>
                          <path
                            fill="#ffcebf"
                            d="m305.337 356.452.004-.003-16.625-4.545a3.161 3.161 0 0 1-2.215-2.216l-.992-3.629-9.156 9.156a13.553 13.553 0 0 1-4.789 3.071l-35.277 13.22-1.438 3.64c-1.483 3.754 2.201 7.483 5.991 6.063l61.169-22.923a13.747 13.747 0 0 0 3.328-1.834z"
                            opacity="1"
                            data-original="#ffcebf"
                          ></path>
                          <path
                            fill="#00516a"
                            d="M502.578 159.437c6.315-6.27 7.849-16.998 1.78-23.508l-23.223-23.222c-6.146-6.586-16.527-6.765-22.897-.395l-29.837 29.837 45.732 45.732z"
                            opacity="1"
                            data-original="#00516a"
                          ></path>
                          <path
                            fill="#004651"
                            d="M473.912 135.929c6.068 6.51 4.535 17.238-1.78 23.508l-13.221 13.221 15.223 15.223.001-.001 28.443-28.443c6.315-6.27 7.849-16.998 1.78-23.508l-23.223-23.222c-6.146-6.586-16.527-6.765-22.897-.395l-3.972 3.972z"
                            opacity="1"
                            data-original="#004651"
                          ></path>
                          <path
                            fill="#00516a"
                            d="M115.081 443.24c-24.428-10.883-42.193-37.258-43.203-64.138-1.053-28.061 16.171-47.211 31.368-64.105 12.545-13.947 23.379-25.991 21.607-39.919-2.731-21.468-34.466-37.902-60.607-47.909a7.61 7.61 0 0 1-4.387-9.83 7.609 7.609 0 0 1 9.83-4.387c44.282 16.95 67.267 36.644 70.266 60.203 2.652 20.845-11.604 36.694-25.39 52.021-13.911 15.465-28.295 31.457-27.473 53.354.787 20.962 15.165 42.329 34.185 50.804 27.315 12.167 63.155-.911 85.211-31.109a7.612 7.612 0 0 1 12.293 8.979c-25.176 34.475-66.848 52.454-103.7 36.036zM266.207 153.717H92.072c-4.204 0-7.611-3.407-7.611-7.611s3.407-7.611 7.611-7.611h174.135a7.611 7.611 0 1 1 0 15.222zM235.761 184.163H122.518c-4.204 0-7.611-3.407-7.611-7.611s3.407-7.611 7.611-7.611h113.243c4.204 0 7.611 3.407 7.611 7.611s-3.407 7.611-7.611 7.611z"
                            opacity="1"
                            data-original="#00516a"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="industriesWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>industries</h2>
                  <p>
                    Welcome to HummingTec, where innovation drives tailored
                    technology solutions across Healthcare, Manufacturing,
                    Mobility, Hospitality, Fashion, and Education. We help your
                    business grow by delivering creative, industry-focused
                    digital solutions that transform possibilities into success.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid pad0px">
            <div className="row mar0px">
              <div className="col-md-12 pad0px">
                <Slider {...settings1}>
                  <div className="imgsWrap">
                    <div
                      className="imgs"
                      style={{ backgroundImage: `url(${HealthcareImg})` }}
                    ></div>
                  </div>
                  <div className="imgsWrap">
                    <div
                      className="imgs"
                      style={{ backgroundImage: `url(${ManufacturingImg})` }}
                    ></div>
                  </div>
                  <div className="imgsWrap">
                    <div
                      className="imgs"
                      style={{ backgroundImage: `url(${MobillityImg})` }}
                    ></div>
                  </div>
                  <div className="imgsWrap">
                    <div
                      className="imgs"
                      style={{ backgroundImage: `url(${HospitalityImg})` }}
                    ></div>
                  </div>
                  <div className="imgsWrap">
                    <div
                      className="imgs"
                      style={{ backgroundImage: `url(${Construction})` }}
                    ></div>
                  </div>
                  <div className="imgsWrap">
                    <div
                      className="imgs"
                      style={{ backgroundImage: `url(${EducationImg})` }}
                    ></div>
                  </div>
                </Slider>
                <div className="itemSlider">
                  <Slider {...settings2}>
                    <div className="itemWrap">
                      <div className="dataWrap">
                        <h2>Healthcare</h2>
                        <p>
                          Elevating healthcare through innovation and compassion
                        </p>
                        <Link to="/Healthcare">
                          Read More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="36"
                            height="36"
                            x="0"
                            y="0"
                            viewBox="0 0 100 100"
                          >
                            <g>
                              <path
                                d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <path
                                fill-rule="evenodd"
                                d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <circle
                                cx="25.52"
                                cy="50"
                                r="2"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></circle>
                              <path
                                d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                            </g>
                          </svg>
                        </Link>
                      </div>
                    </div>
                    <div className="itemWrap">
                      <div className="dataWrap">
                        <h2>Manufacturing</h2>
                        <p>Pioneering excellence in manufacturing</p>
                        <Link to="/Manufacturing">
                          Read More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="36"
                            height="36"
                            x="0"
                            y="0"
                            viewBox="0 0 100 100"
                          >
                            <g>
                              <path
                                d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <path
                                fill-rule="evenodd"
                                d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <circle
                                cx="25.52"
                                cy="50"
                                r="2"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></circle>
                              <path
                                d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                            </g>
                          </svg>
                        </Link>
                      </div>
                    </div>
                    <div className="itemWrap">
                      <div className="dataWrap">
                        <h2>Mobillity</h2>
                        <p>Empowering seamless mobility solutions</p>
                        <Link to="/Mobility">
                          Read More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="36"
                            height="36"
                            x="0"
                            y="0"
                            viewBox="0 0 100 100"
                          >
                            <g>
                              <path
                                d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <path
                                fill-rule="evenodd"
                                d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <circle
                                cx="25.52"
                                cy="50"
                                r="2"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></circle>
                              <path
                                d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                            </g>
                          </svg>
                        </Link>
                      </div>
                    </div>
                    <div className="itemWrap">
                      <div className="dataWrap">
                        <h2>Hospitality</h2>
                        <p>Elevating hospitality to new heights</p>
                        <Link to="/Hospitality">
                          Read More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="36"
                            height="36"
                            x="0"
                            y="0"
                            viewBox="0 0 100 100"
                          >
                            <g>
                              <path
                                d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <path
                                fill-rule="evenodd"
                                d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <circle
                                cx="25.52"
                                cy="50"
                                r="2"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></circle>
                              <path
                                d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                            </g>
                          </svg>
                        </Link>
                      </div>
                    </div>
                    <div className="itemWrap">
                      <div className="dataWrap">
                        <h2>Construction</h2>
                        <p>
                          Transforming the Construction Industry with Innovative
                          Technology
                        </p>
                        <Link to="/Construction">
                          Read More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="36"
                            height="36"
                            x="0"
                            y="0"
                            viewBox="0 0 100 100"
                          >
                            <g>
                              <path
                                d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <path
                                fill-rule="evenodd"
                                d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <circle
                                cx="25.52"
                                cy="50"
                                r="2"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></circle>
                              <path
                                d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                            </g>
                          </svg>
                        </Link>
                      </div>
                    </div>
                    <div className="itemWrap">
                      <div className="dataWrap">
                        <h2>Education</h2>
                        <p>Inspiring minds, shaping futures</p>
                        <Link to="/Education">
                          Read More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="36"
                            height="36"
                            x="0"
                            y="0"
                            viewBox="0 0 100 100"
                          >
                            <g>
                              <path
                                d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <path
                                fill-rule="evenodd"
                                d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                              <circle
                                cx="25.52"
                                cy="50"
                                r="2"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></circle>
                              <path
                                d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                            </g>
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="productWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <section id="slider">
                                    <input type="radio" name="slider" id="s1" data-slide="1" checked={currentSlide === 1} onChange={() => setCurrentSlide(1)}
                                    />
                                    <input type="radio" name="slider" id="s2" data-slide="2" checked={currentSlide === 2} onChange={() => setCurrentSlide(2)}
                                    />
                                    <input type="radio" name="slider" id="s3" data-slide="3" checked={currentSlide === 3} onChange={() => setCurrentSlide(3)}
                                    />
                                    <input type="radio" name="slider" id="s4" data-slide="4" checked={currentSlide === 4} onChange={() => setCurrentSlide(4)}
                                    />
                                    <input type="radio" name="slider" id="s5" data-slide="5" checked={currentSlide === 5} onChange={() => setCurrentSlide(5)}
                                    />
                                    <label htmlFor="s1" id="slide1" className="productSlde productSlde1">
                                        <div className="zoom-container" data-slide="1">
                                            <div className="dataWrap">
                                                <h2>Products</h2>
                                                <p>Unveil the symphony of HummingTec's products! From the dynamic MetaHOS and harmonious SYMBIO to our ERP Solution, Learning Management, Booking Management...</p>
                                                <Link to="/Symbio">view more</Link>
                                            </div>
                                        </div>
                                    </label>

                                    <label htmlFor="s2" id="slide2" className="productSlde productSlde2">
                                        <div className="zoom-container" data-slide="2">
                                            <div className="dataWrap">
                                                <h2>MetaHOS</h2>
                                                <p>Redefining healthcare excellence</p>
                                                <Link to="/MetaHOS">
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" x="0" y="0" viewBox="0 0 100 100">
                                                        <g>
                                                            <path d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z" fill="#FFAA47" opacity="1" data-original="#FFAA47"></path>
                                                            <path fill-rule="evenodd" d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z" clip-rule="evenodd" fill="#FFAA47" opacity="1" data-original="#FFAA47"></path>
                                                            <circle cx="25.52" cy="50" r="2" fill-rule="evenodd" clip-rule="evenodd" fill="#FFAA47" opacity="1" data-original="#FFAA47"></circle>
                                                            <path d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z" fill="#FFAA47" opacity="1" data-original="#FFAA47"></path>
                                                        </g>
                                                    </svg>
                                                </Link>
                                            </div>
                                            <div className="imgWrap">
                                                <img src={productsliderImg1} alt="" className="img-fluid" />
                                            </div>
                                        </div>
                                    </label>

                                    <label htmlFor="s3" id="slide3" className="productSlde productSlde3">
                                        <div className="zoom-container" data-slide="3">
                                            <div className="dataWrap">
                                                <h2>SYMBIO</h2>
                                                <p>Where innovation meets impact</p>
                                                <Link to="/Symbio">
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" x="0" y="0" viewBox="0 0 100 100">
                                                        <g>
                                                            <path d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z" fill="#F6635C" opacity="1" data-original="#F6635C"></path>
                                                            <path fill-rule="evenodd" d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z" clip-rule="evenodd" fill="#F6635C" opacity="1" data-original="#F6635C"></path>
                                                            <circle cx="25.52" cy="50" r="2" fill-rule="evenodd" clip-rule="evenodd" fill="#F6635C" opacity="1" data-original="#F6635C"></circle>
                                                            <path d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z" fill="#F6635C" opacity="1" data-original="#F6635C"></path>
                                                        </g>
                                                    </svg>
                                                </Link>
                                            </div>
                                            <div className="imgWrap">
                                                <img src={productsliderImg2} alt="" className="img-fluid" />
                                            </div>
                                        </div>
                                    </label>

                                    <label htmlFor="s4" id="slide4" className="productSlde productSlde4">
                                        <div className="zoom-container" data-slide="4">
                                            <div className="dataWrap">
                                                <h2>ERP Solution</h2>
                                                <p>Streamlining operations for sustained growth and success</p>
                                                <Link to="">
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" x="0" y="0" viewBox="0 0 100 100">
                                                        <g>
                                                            <path d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z" fill="#FF4037" opacity="1" data-original="#FF4037"></path>
                                                            <path fill-rule="evenodd" d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z" clip-rule="evenodd" fill="#FF4037" opacity="1" data-original="#FF4037"></path>
                                                            <circle cx="25.52" cy="50" r="2" fill-rule="evenodd" clip-rule="evenodd" fill="#FF4037" opacity="1" data-original="#FF4037"></circle>
                                                            <path d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z" fill="#FF4037" opacity="1" data-original="#FF4037"></path>
                                                        </g>
                                                    </svg>
                                                </Link>
                                            </div>
                                            <div className="imgWrap">
                                                <img src={productsliderImg3} alt="" className="img-fluid" />
                                            </div>
                                        </div>
                                    </label>

                                    <label htmlFor="s5" id="slide5" className="productSlde productSlde5">
                                        <div className="zoom-container" data-slide="5">
                                            <div className="dataWrap">
                                                <h2>Learning management</h2>
                                                <p>Elevate learning experiences with our intuitive platform</p>
                                                <Link to="/LearningManagement">
                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" x="0" y="0" viewBox="0 0 100 100">
                                                        <g>
                                                            <path d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z" fill="#C23373" opacity="1" data-original="#C23373"></path>
                                                            <path fill-rule="evenodd" d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z" clip-rule="evenodd" fill="#C23373" opacity="1" data-original="#C23373"></path>
                                                            <circle cx="25.52" cy="50" r="2" fill-rule="evenodd" clip-rule="evenodd" fill="#C23373" opacity="1" data-original="#C23373"></circle>
                                                            <path d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z" fill="#C23373" opacity="1" data-original="#C23373"></path>
                                                        </g>
                                                    </svg>
                                                </Link>
                                            </div>
                                            <div className="imgWrap">
                                                <img src={productsliderImg4} alt="" className="img-fluid" />
                                            </div>
                                        </div>
                                    </label>
                                </section>
                            </div>
                        </div>
                    </div>
                </div> */}
        <div className="whyUsWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div class="titleWrap">
                  <h2>Why Choose Hummingtec</h2>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="leftWrap">
                  <div className="videoWrap">
                    <iframe
                      width="100%"
                      height="100%"
                      src="https://www.youtube.com/embed/Kro-QVMj97s?autoplay=1&mute=1"
                      title="Technovent Solution's Pitch at 'CODE FOR THE NEXT BILLION'"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      frameborder="0"
                      allowfullscreen="allowfullscreen"
                    ></iframe>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="rightWrap">
                  <div class="dataWrap">
                    <p>
                      To thrive in the digital age, businesses must stay ahead
                      with innovative technologies. At Hummingtec, we partner
                      with you to envision, execute, and accelerate cutting-edge
                      digital and mobile solutions that transform existing
                      operations, build new products, and augment your teams
                      with specialized expertise. Leveraging a global network of
                      technology experts, we deliver tailored solutions that
                      drive efficiency, growth, and digital excellence.
                    </p>
                    <h6>
                      Proudly recognized as winners of the prestigious “Code for
                      the Next Billion” award by NASSCOM, CNBC-18, and Facebook,
                      we stand among the top 10 most innovative companies in
                      Education, Healthcare, Social Welfare, and Finance
                      sectors, underscoring our commitment to impactful
                      technology innovation.
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="homeIntroWrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-4">
                <div className="itemWrap">
                  <div className="iconWrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="106"
                      height="91"
                      viewBox="0 0 106 91"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M56.6944 0.0342636C76.833 0.491123 97.5402 8.37687 103.972 27.4618C110.585 47.0842 100.304 67.6011 83.5837 79.8211C66.6919 92.1668 44.3028 95.4381 26.9424 83.7603C7.50212 70.6834 -5.52635 47.2296 2.31758 25.1557C9.70767 4.35902 34.6248 -0.4664 56.6944 0.0342636Z"
                        fill="#fbbf24"
                        opacity="0.26"
                      ></path>
                    </svg>
                    <div className="imgWrap">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="52"
                        height="52"
                        x="0"
                        y="0"
                        viewBox="0 0 682.667 682.667"
                      >
                        <g>
                          <defs>
                            <clipPath id="a" clipPathUnits="userSpaceOnUse">
                              <path
                                d="M0 512h512V0H0Z"
                                fill="#701A75"
                                opacity="1"
                                data-original="#701A75"
                              ></path>
                            </clipPath>
                          </defs>
                          <g
                            clip-path="url(#a)"
                            transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                          >
                            <path
                              d="M0 0h96.19c13.282 0 24.049-10.767 24.049-24.048v-280.565"
                              transform="translate(344.18 360.21)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="M0 0v280.565c0 13.281 10.767 24.048 24.048 24.048h96.194"
                              transform="translate(47.58 55.597)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="M0 0h360.723v-16.032c0-8.855-7.178-16.032-16.033-16.032h-464.935c-8.855 0-16.032 7.177-16.032 16.032V0h104.206"
                              transform="translate(143.777 55.597)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="M0 0c19.01 29.685 30.215 65.506 30.215 104.21 0 53.963-21.695 102.389-56.113 136.274-34.417-33.885-56.113-82.311-56.113-136.274 0-38.704 11.205-74.525 30.215-104.21z"
                              transform="translate(281.898 247.984)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="M0 0h-64.129l8.016 32.064h48.097z"
                              transform="translate(288.065 215.92)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="m0 0-34.507-41.408a24.05 24.05 0 0 1-5.574-15.395v-23.358l57.099 32.218"
                              transform="translate(199.887 312.113)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="m0 0 34.507-41.408a24.05 24.05 0 0 0 5.574-15.395v-23.358l-57.099 32.218"
                              transform="translate(312.113 312.113)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="M0 0h80.161"
                              transform="translate(215.92 424.339)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="M0 0a56.053 56.053 0 0 1 2.354 16.032c0 30.991-25.123 56.113-56.113 56.113-6.433 0-12.588-1.136-18.344-3.129-5.392 15.767-20.174 27.178-37.769 27.178-9.811 0-18.681-3.664-25.648-9.518.946 3.026 1.6 6.18 1.6 9.518 0 17.709-14.355 32.064-32.064 32.064s-32.065-14.355-32.065-32.064c0-3.338.654-6.492 1.6-9.518-6.967 5.854-15.837 9.518-25.648 9.518-17.595 0-32.377-11.411-37.769-27.178-5.756 1.993-11.911 3.129-18.344 3.129-30.99 0-56.113-25.122-56.113-56.113 0-5.575.841-10.949 2.354-16.032"
                              transform="translate(421.984 55.597)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                            <path
                              d="M0 0c0-13.281-10.767-24.048-24.048-24.048-13.282 0-24.049 10.767-24.049 24.048 0 13.281 10.767 24.048 24.049 24.048C-10.767 24.048 0 13.281 0 0Z"
                              transform="translate(280.048 360.21)"
                              fill="none"
                              stroke="#701A75"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#701A75"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="dataWrap">
                    <h2>Startups</h2>
                    <p>
                      Unleash your startup's potential with cutting-edge
                      software solutions – click to transform your vision into
                      reality!
                    </p>
                    <Link to="/Startups">
                      Learn More
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="24"
                        height="24"
                        x="0"
                        y="0"
                        viewBox="0 0 100 100"
                      >
                        <g>
                          <path
                            d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                            clip-rule="evenodd"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                          <circle
                            cx="25.52"
                            cy="50"
                            r="2"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></circle>
                          <path
                            d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                        </g>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <div className="iconWrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="106"
                      height="91"
                      viewBox="0 0 106 91"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M56.6944 0.0342636C76.833 0.491123 97.5402 8.37687 103.972 27.4618C110.585 47.0842 100.304 67.6011 83.5837 79.8211C66.6919 92.1668 44.3028 95.4381 26.9424 83.7603C7.50212 70.6834 -5.52635 47.2296 2.31758 25.1557C9.70767 4.35902 34.6248 -0.4664 56.6944 0.0342636Z"
                        fill="#fbbf24"
                        opacity="0.26"
                      ></path>
                    </svg>
                    <div className="imgWrap">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="54"
                        height="54"
                        x="0"
                        y="0"
                        viewBox="0 0 64 64"
                      >
                        <g>
                          <path
                            d="M16 33v7h-4a1 1 0 0 0-1 1 21 21 0 0 0 42 0 1 1 0 0 0-1-1h-4v-7a3 3 0 0 0-3-3h-.382a4 4 0 1 0-5.236 0H39a2.981 2.981 0 0 0-2 .78 2.981 2.981 0 0 0-2-.78h-.382a4 4 0 1 0-5.236 0H29a2.981 2.981 0 0 0-2 .78 2.981 2.981 0 0 0-2-.78h-.786a3.962 3.962 0 0 0 1.394-3 4.034 4.034 0 0 0-8.067 0 3.961 3.961 0 0 0 1.4 3.006A3 3 0 0 0 16 33Zm5.545 23.85a19.143 19.143 0 0 1-4.918-4.7 31.464 31.464 0 0 1 5.212-1.425 24.794 24.794 0 0 0 2.278 5.571q-1.357.238-2.572.554Zm2.279-6.45a58.415 58.415 0 0 1 16.352 0 21.555 21.555 0 0 1-2.44 5.58 51.359 51.359 0 0 0-11.473 0 21.536 21.536 0 0 1-2.439-5.58ZM32 60a18.851 18.851 0 0 1-7.785-1.691c.545-.1 1.1-.194 1.681-.274a49.183 49.183 0 0 1 12.2 0c.581.081 1.14.175 1.687.275A18.855 18.855 0 0 1 32 60Zm10.455-3.15q-1.213-.315-2.572-.556a24.822 24.822 0 0 0 2.278-5.571 31.464 31.464 0 0 1 5.212 1.425 19.143 19.143 0 0 1-4.918 4.702ZM50.974 42a18.855 18.855 0 0 1-2.494 8.431 32.41 32.41 0 0 0-5.853-1.655A36.857 36.857 0 0 0 43.406 42ZM42 25a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm-4 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v7h-8Zm-6-8a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm-4 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v7h-8Zm13.406 9a34.677 34.677 0 0 1-.754 6.45 60.294 60.294 0 0 0-17.3 0 34.687 34.687 0 0 1-.758-6.45ZM21.575 25a2 2 0 1 1-2.034 2 2.019 2.019 0 0 1 2.034-2ZM18 33a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v7h-8Zm2.594 9a36.846 36.846 0 0 0 .779 6.775 32.512 32.512 0 0 0-5.853 1.656A18.855 18.855 0 0 1 13.026 42ZM23.059 13.1a1.72 1.72 0 0 0 .193 1.348l1.289 2.133a1.835 1.835 0 0 0 2.437.641l.376-.208a7.788 7.788 0 0 0 1.554.867v.349A1.788 1.788 0 0 0 30.711 20h2.578a1.788 1.788 0 0 0 1.8-1.768v-.349a7.816 7.816 0 0 0 1.554-.867l.377.208a1.833 1.833 0 0 0 2.436-.64l1.289-2.133a1.723 1.723 0 0 0 .193-1.349 1.786 1.786 0 0 0-.86-1.094l-.33-.181a7 7 0 0 0 0-1.654l.331-.182a1.783 1.783 0 0 0 .862-1.091 1.72 1.72 0 0 0-.193-1.348l-1.289-2.135a1.834 1.834 0 0 0-2.437-.641l-.376.208a7.788 7.788 0 0 0-1.554-.867v-.349A1.788 1.788 0 0 0 33.289 2h-2.578a1.788 1.788 0 0 0-1.8 1.768v.349a7.816 7.816 0 0 0-1.554.867l-.377-.208a1.834 1.834 0 0 0-2.436.64l-1.292 2.133a1.723 1.723 0 0 0-.193 1.351 1.786 1.786 0 0 0 .86 1.094l.33.181a7 7 0 0 0 0 1.654l-.331.182a1.783 1.783 0 0 0-.859 1.089ZM26.2 11a5.273 5.273 0 0 1 .053-.737 1.754 1.754 0 0 0-.9-1.765l-.253-.139 1.057-1.751.324.179a1.856 1.856 0 0 0 1.99-.143 5.893 5.893 0 0 1 1.284-.713 1.786 1.786 0 0 0 1.153-1.648V4h2.184v.283a1.786 1.786 0 0 0 1.153 1.648 5.863 5.863 0 0 1 1.283.713 1.858 1.858 0 0 0 1.991.143l.324-.179L38.9 8.359l-.252.139a1.755 1.755 0 0 0-.9 1.766 5.144 5.144 0 0 1 0 1.473 1.754 1.754 0 0 0 .9 1.765l.251.139-1.057 1.751-.324-.179a1.861 1.861 0 0 0-1.99.143 5.893 5.893 0 0 1-1.284.713 1.786 1.786 0 0 0-1.153 1.648V18h-2.183v-.283a1.786 1.786 0 0 0-1.153-1.648 5.863 5.863 0 0 1-1.283-.713 1.864 1.864 0 0 0-1.991-.143l-.324.179-1.057-1.751.252-.139a1.755 1.755 0 0 0 .9-1.766A5.247 5.247 0 0 1 26.2 11Z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                          <path
                            d="M32 15a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2ZM42.8 7l.161 2c6.249-.508 11.171 1.162 13.852 4.71 4.173 5.522 2.268 14.812-4.853 23.668l1.559 1.252c7.714-9.593 9.634-19.848 4.89-26.126C55.3 8.386 49.758 6.432 42.8 7ZM13.771 56.59l.458-1.947a11.916 11.916 0 0 1-7.042-4.291 12.368 12.368 0 0 1-2.008-9.433C6.291 33.231 12.466 24.4 21.3 17.878q.634-.469 1.276-.914l-1.142-1.643c-.443.309-.885.624-1.323.949C10.724 23.2 4.4 32.311 3.2 40.633a14.309 14.309 0 0 0 2.391 10.925 13.863 13.863 0 0 0 8.18 5.032Z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="dataWrap">
                    <h2>SMB’s</h2>
                    <p>
                      Empower your business with bespoke software solutions –
                      click here to drive growth and innovation!
                    </p>
                    <Link to="/SMBs">
                      Learn More
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="24"
                        height="24"
                        x="0"
                        y="0"
                        viewBox="0 0 100 100"
                      >
                        <g>
                          <path
                            d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                            clip-rule="evenodd"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                          <circle
                            cx="25.52"
                            cy="50"
                            r="2"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></circle>
                          <path
                            d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                        </g>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <div className="iconWrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="106"
                      height="91"
                      viewBox="0 0 106 91"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M56.6944 0.0342636C76.833 0.491123 97.5402 8.37687 103.972 27.4618C110.585 47.0842 100.304 67.6011 83.5837 79.8211C66.6919 92.1668 44.3028 95.4381 26.9424 83.7603C7.50212 70.6834 -5.52635 47.2296 2.31758 25.1557C9.70767 4.35902 34.6248 -0.4664 56.6944 0.0342636Z"
                        fill="#fbbf24"
                        opacity="0.26"
                      ></path>
                    </svg>
                    <div className="imgWrap">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="48"
                        height="48"
                        x="0"
                        y="0"
                        viewBox="0 0 1707 1707"
                        fill-rule="evenodd"
                      >
                        <g>
                          <path
                            d="M701 710H528c-16 0-30-13-30-30V513c0-16 14-30 30-30h173c16 0 29 14 29 30v167c0 17-13 30-29 30zm969 874H36c-16 0-29-14-29-30v-126c0-17 13-30 29-30h78V424c0-13 9-25 21-29l646-200V43c0-17 13-30 30-30h752c16 0 29 13 29 30v1355h78c17 0 30 13 30 30v126c0 16-13 30-30 30zM66 1524h1575v-66H66zm774-126h108V839c0-17 13-30 30-30h417c17 0 30 13 30 30v559h108V73H840zm-666 0h607V257L174 446zm833 0h150V868h-150zm209 0h150V868h-150zm-84-724H916c-16 0-30-13-30-30V462c0-17 14-30 30-30h216c17 0 30 13 30 30v182c0 16-13 30-30 30zm-186-60h157V492H946zm511 60h-216c-17 0-30-13-30-30V462c0-17 13-30 30-30h216c16 0 30 13 30 30v182c0 16-14 30-30 30zm-187-60h157V492h-157zm-138-239H916c-16 0-30-14-30-30V163c0-17 14-30 30-30h216c17 0 30 13 30 30v182c0 16-13 30-30 30zm-186-60h157V193H946zm511 60h-216c-17 0-30-14-30-30V163c0-17 13-30 30-30h216c16 0 30 13 30 30v182c0 16-14 30-30 30zm-187-60h157V193h-157zM533 1694H36c-39 0-39-60 0-60h497c39 0 39 60 0 60zm1137 0h-496c-39 0-39-60 0-60h496c39 0 39 60 0 60zM426 1278H254c-16 0-30-13-30-30v-167c0-17 14-30 30-30h172c17 0 30 13 30 30v167c0 17-13 30-30 30zm-142-60h113v-107H284zm417 60H528c-16 0-30-13-30-30v-167c0-17 14-30 30-30h173c16 0 29 13 29 30v167c0 17-13 30-29 30zm-143-60h113v-107H558zM426 994H254c-16 0-30-13-30-30V797c0-16 14-30 30-30h172c17 0 30 14 30 30v167c0 17-13 30-30 30zm-142-59h113V827H284zm417 59H528c-16 0-30-13-30-30V797c0-16 14-30 30-30h173c16 0 29 14 29 30v167c0 17-13 30-29 30zm-143-59h113V827H558zM426 710H254c-16 0-30-13-30-30V513c0-16 14-30 30-30h172c17 0 30 14 30 30v167c0 17-13 30-30 30zm-142-59h113V543H284zm274 0h113V543H558z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="dataWrap">
                    <h2>Enterprise</h2>
                    <p>
                      Scale your enterprise with robust, tailor-made software
                      solutions – click to elevate your operational excellence!
                    </p>
                    <Link to="/EnterprisesCustomers">
                      Learn More
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        width="24"
                        height="24"
                        x="0"
                        y="0"
                        viewBox="0 0 100 100"
                      >
                        <g>
                          <path
                            d="M86.29 52H34.6c-1.1 0-2-.9-2-2s.9-2 2-2h51.69c1.1 0 2 .9 2 2s-.9 2-2 2z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M16.45 48c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .89-2 2-2z"
                            clip-rule="evenodd"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                          <circle
                            cx="25.52"
                            cy="50"
                            r="2"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></circle>
                          <path
                            d="M73 67.62a2.008 2.008 0 0 1-1.52-3.3L83.66 50 71.48 35.67c-.72-.84-.61-2.1.23-2.82s2.1-.61 2.82.23L87.81 48.7c.63.75.63 1.84 0 2.59L74.53 66.92c-.4.47-.96.7-1.53.7z"
                            fill="#701A75"
                            opacity="1"
                            data-original="#701A75"
                          ></path>
                        </g>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="testimonialsWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>What customers are saying about Hummingtec</h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-9 col-lg-11">
                <Slider {...testimonialSlider}>
                  <div className="itemWrap">
                    <div className="innerWrap">
                      <div className="dataWrap">
                        <div className="topWrap">
                          <div className="leftWrap">
                            <h2>Dr. Troy Anderson </h2>
                            <span>
                              Founder of Phoenix Neurology and Sleep Medicine
                            </span>
                          </div>
                          <div className="rightWrap">
                            <img
                              src={PhoenixNeurologyLogo}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                        <p>
                          We were impressed by the depth of the UX analysis they
                          did in terms of our customer's research, buyer persona
                          creation, user journey mapping, etc. All the
                          information like research findings, for instance, was
                          presented in a clear form (presentations, Miro boards,
                          clear infographics) so it was quite easy to understand
                          what we need to build and why.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemWrap">
                    <div className="innerWrap">
                      <div className="dataWrap">
                        <div className="topWrap">
                          <div className="leftWrap">
                            <h2>Mr. Arun Bharadwaj</h2>
                            <span>Director at Star Sky Connect</span>
                          </div>
                          <div className="rightWrap">
                            <img
                              src={starSkyConnectLogo}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                        <p>
                          Working with Hummingtec has been a game-changer for
                          Star Sky Connect. Their team expertly designed and
                          deployed a robust, scalable cloud infrastructure
                          tailored to our needs. From architecture planning to
                          deployment, every step was handled with precision and
                          clarity. What impressed us most was their ability to
                          balance performance, security, and cost-efficiency
                          without compromise. Thanks to Hummingtec, we now have
                          a reliable foundation that supports our growth and
                          innovation seamlessly.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemWrap">
                    <div className="innerWrap">
                      <div className="dataWrap">
                        <div className="topWrap">
                          <div className="leftWrap">
                            <h2>Mr. Shanmugam Shan</h2>
                            <span>
                              Project Manager at China Railway Construction
                              Company
                            </span>
                          </div>
                          <div className="rightWrap">
                            <img
                              src={chunaRailwayConstructionLogo}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                        <p>
                          Hummingtec delivered a comprehensive ERP solution that
                          transformed how we manage our operations at China
                          Railway Construction Company. Their team demonstrated
                          a deep understanding of our complex workflows and
                          built a system that seamlessly integrates procurement,
                          inventory, HR, and project tracking. The solution has
                          significantly improved our efficiency, visibility, and
                          decision-making across departments. We appreciate
                          their technical expertise, responsiveness, and
                          commitment to excellence.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemWrap">
                    <div className="innerWrap">
                      <div className="dataWrap">
                        <div className="topWrap">
                          <div className="leftWrap">
                            <h2>Dr. Simon Yesu </h2>
                            <span>
                              Registrar at Spicer Adventist University
                            </span>
                          </div>
                          <div className="rightWrap">
                            <img
                              src={SpicerAdventistUniversityLogo}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </div>
                        <p>
                          Partnering with Hummingtec to build our University
                          Management Solution was one of the best decisions
                          we've made. Their team took the time to understand the
                          unique needs of our institution and delivered a
                          platform that streamlined admissions, academic
                          management, and student engagement. The system is
                          intuitive, reliable, and has greatly improved
                          operational efficiency for both faculty and
                          administration. Hummingtec's professionalism and
                          support have been outstanding throughout the project.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
        <div className="ourPartnerWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Our Partners</h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <ul>
                  <li>
                    <img src={AdobeImg} class="img-fluid" alt="" />
                  </li>
                  <li>
                    <img src={GoogleImg} class="img-fluid" alt="" />
                  </li>
                  <li>
                    <img src={MicrosoftImg} class="img-fluid" alt="" />
                  </li>
                  <li>
                    <img src={AwsImg} class="img-fluid" alt="" />
                  </li>
                  <li>
                    <img src={ShopifyImg} class="img-fluid" alt="" />
                  </li>
                  <li>
                    <img src={ZohoImg} class="img-fluid" alt="" />
                  </li>
                  <li>
                    <img src={IBMImg} class="img-fluid" alt="" />
                  </li>
                  <li>
                    <img src={DatabricksImg} class="img-fluid" alt="" />
                  </li>
                  <li>
                    <img src={OpenAIImg} class="img-fluid" alt="" />
                  </li>
                  {/* <li>
                                        <img src={TheVergeImg} class="img-fluid" alt="" />
                                    </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="recommendWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="titleWrap">
                                    <h2>Recommended For You</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="dataWrap">
                                        <p>Resources</p>
                                        <h2>5 Questions to Ask Before You Use SAS for Your Next Analytics Project</h2>
                                        <a href="#">Learn More</a>
                                    </div>
                                    <div className="imgWrap">
                                        <img src={recommendedImg} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="dataWrap">
                                        <p>Resources</p>
                                        <h2>5 Questions to Ask Before You Use SAS for Your Next Analytics Project</h2>
                                        <a href="#">Learn More</a>
                                    </div>
                                    <div className="imgWrap">
                                        <img src={recommendedImg} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="dataWrap">
                                        <p>Resources</p>
                                        <h2>5 Questions to Ask Before You Use SAS for Your Next Analytics Project</h2>
                                        <a href="#">Learn More</a>
                                    </div>
                                    <div className="imgWrap">
                                        <img src={recommendedImg} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          className="contactUsPopup"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="titleWrap">
              <h2>Let's get in touch</h2>
              <p>
                Kindly fill out the form below, and our team will promptly
                respond to your inquiries.
              </p>
            </div>
            <form onSubmit={handleSubmit}>
              <ul className="formList">
                <li>
                  <div className="inputField">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </li>
                <li>
                  <div className="inputField">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </li>
                <li>
                  <div className="inputField">
                    <label>Mobile Number</label>
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                  </div>
                </li>
                <li>
                  <div className="inputField selectField">
                    <label>I'm interested in:</label>
                    <select
                      name="interest"
                      value={formData.interest}
                      onChange={handleChange}
                    >
                      <option value="">Select an option</option>
                      <option>Artificial Intelligence</option>
                      <option>Machine Learning</option>
                      <option>Custom GPT</option>
                      <option>Blockchain/Etherium</option>
                      <option>E-Commerce/Shopping Cart</option>
                      <option>Salesforce CRM</option>
                      <option>Zoho CRM</option>
                      <option>Custom CRM</option>
                      <option>Website Development</option>
                      <option>SEO</option>
                      <option>Social Media Management</option>
                      <option>Mobile Application Development</option>
                      <option>Custom Application Development</option>
                      <option>Security and Testing</option>
                      <option>Other</option>
                    </select>
                  </div>
                </li>
                <li className="full">
                  <div className="inputField">
                    <label>Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </li>

                <li className="full">
                  <div className="inputField">
                    <ReCAPTCHA
                      sitekey="6LfVNpMrAAAAAIfAv93ShHt8EO2h8gDh8WZRy4vW"
                      onChange={handleCaptchaChange}
                      ref={recaptchaRef}
                    />
                  </div>
                </li>
                <li className="full">
                  <div className="ctaWrap">
                    <button type="submit" className="btnSubmti">
                      Submit
                    </button>
                  </div>
                </li>
              </ul>
            </form>
          </Modal.Body>
        </Modal>
        <Modal
          size="md"
          show={showThankYou}
          onHide={() => setShowThankYou(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          className="contactUsPopup"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="thankYouPopup">
              <h3>Thank you for contacting us!</h3>
              <p>We will respond to your inquiry shortly.</p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      <Footer></Footer>
    </>
  );
};
export default Home;
